/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';

import { connect } from 'react-redux';
import { Row, Col, InputGroup, FormControl, Button, Modal, OverlayTrigger, Popover, Table, Form, Spinner, Tooltip } from "react-bootstrap";

import { SalesService, LocationService, ItemsService, CommonService,InvoiceService } from 'shared/services';
import  PersonalInfoService  from 'shared/services/PersonalInfoService';
import moment from 'moment-timezone';
import store from 'features/store';

import { dateTimeFormat, getCountDown, getDays, getDurationBgColor, minTwoDigits, stringToHTMLConvert, titleCase } from 'shared/modifiers';
import { handleToken, isAuthorized, logout } from 'shared/settings/auth';
import validators from 'shared/validators';
import VideoThumbnail from 'shared/video-thumbnail/VideoThumbnail';
import { image_thumbnail, loaderIcon, shippable } from 'shared/images/images';

import { getBuyerHeaders, getBuyersUrl, getSellerUrl } from 'shared/http';
import { bidsSseEvent, bidsSseEventAdd, eligibleCategoryandLocation, irmDetails, seelDetailsData, seelGDDetailsData, suspendList } from 'shared/settings/apiconfig';
import { disablePreviousState } from 'shared/settings/stateMaintain';

import { enablePreviousState, estateSaleCategory, removeStateMaintainValue, SaleCardView } from 'shared/settings/stateMaintain';
import ToasterMessage from 'shared/toast/toast';
import { gaID } from 'shared/settings/gaConfig';
import { GalleryImage } from './GalleryView';
import { showAndHideJiraButton } from 'shared/jira-button';
import { initFbPixel, trackCustomEvent } from 'shared/settings/fbPixelConfig';

import { SSE } from 'shared/sse';
import { BID_AMOUNT, CATERGORY } from 'shared/settings/config';
import { generateVideoThumbnails } from 'shared/video-thumbnail/NewThumbnail';
import { addDataLayer, getItemUrl } from 'shared/utils/utils';

import './ItemView.scss';
import axios from 'axios';
import { Helmet } from 'react-helmet';

import { PayPalClientId } from 'shared/settings/config';
/** Paypal */
import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
/**


@Author Karthik

@param

@return Item view html

**/

class ItemView extends Component {
    constructor(props) {
        super(props);
        this.expiration = moment.utc().local().add(30, 'seconds');
        this.imageScrollRef = createRef(); //  Description scroll ref
        this.itemViewRef = createRef(); // item View Ref
        this.readMore = createRef();
        this.magnifier = createRef();
        this.magnifierImage = createRef();
        this.toasterMessage = createRef();
        this.imageContainer = createRef();
        this.defaultGalleryStyle = {
            maxHeight: "100%",
            height: "unset",
            width: 'unset',
            cursor: "zoom-in",
            position: "absolute",
            top: "unset",
        };

        this.state = {
            config: this.props.payPalPage,
            payPalConfig: {
                script: {
                    "client-id": PayPalClientId,
                    currency: "USD",
                    intent: "capture",
                },
                buttonStyle: {
                    shape: 'pill',
                    color: 'white',
                    layout: 'vertical',
                    label: 'checkout',
                }
            },
            placebidLoading: false,
            buynowLoading: false,
            invoiceOrderCreated: false,
            itemisshippable: '',
            paypalbtnDisabled: false,
            windowWidth: window.innerWidth,
            duration: null,
            pageLoading: true,
            saleDetail: {},
            locationDetail: {},
            itemsDetails: {},
            itemImageList: [],
            activeImage: {},
            activeImageIndex: 0,
            descriptionScrollButtons: { disableTop: true, disableDown: false },
            bidConfirmModal: false,
            itemReciptModel: false,
            irmOptionData:  [],
            irmStatus: false,
            itemReceiptValue : '',
            shippingModel: false,
            bidderCheck: false,
            buyNowConfirmModal: false,
            askAQuestion: false,
            totalPriceForBuyNow: { buynowprice: 0, buyerspremium: 0, taxValue: 0, shippingfee: 0, total: 0, applytaxonbp: 0, taxonbpamount: 0, handlingfee: 0 },
            duration_bg_color: "normal",
            saleTitleReadMore: false,
            placeBidForm: {
                amount: { value: '', error: '', validators: [validators.required()] }
            },
            formValid: false,
            messageForm: {
                message: { value: '', error: '', validators: [validators.required(), validators.maxLength(200)] },
                isPublic: { value: "false", error: '', validators: [validators.required()], valid: true }
            },
            messageFormValid: false,
            videoPlayerModal: false,
            bidHistoryModal: false,
            placeBidValue: { total: 0, currentValue: 0, buyerspremiumValue: 0 },
            bidHistory: [],
            currentBid: 0,
            highestBidder: '-',
            removeBuyNow: false,
            incrementvalue: 1,
            bidError: null,
            bidLoading: false,
            watch: [],
            noImage: false,
            noDataFound: false,
            messageList: [],
            messageLoading: false,
            isVisible: false,
            magnifierHide: true,
            locationImage: [],
            bidHistoryData: {},
            reduceTime: 0,
            expandTerms: false,
            buyNowModalHandle: { message: null, loading: false },
            checkingTime: false,
            commonUTCTime: null,
            connectionError: false,
            galleryModal: false,
            galleryMedia: {
                isZoomed: false,
                activeImage: {},
                activeImageIndex: 0,
                styles: JSON.parse(JSON.stringify(this.defaultGalleryStyle)),
                adjustHeight: true,
                adjustWidth: true
            },
            itemClosed: false,
            getCurrentBidValueStatus: "REQUEST",
            refreshData: {},
            imgCropHeight: 0,
            imgCropWidth: 0,
            pageClientWidth: 0,
            nextButtonClicked: false,
            previousButtonClicked: false,
            retryAPI: 0,
            estateTermsConditions: false,
            thumbnailArray: [],
            paymentSelectionModal: false,
            paymentConfirmBtn: false,
            paymentConfirmLoading: false,
            paymentError: false,
            prevPath: this.props?.previousPath?.state?.prevPath,
            videoThumbnails: {},
            shippingto: {
                address: '',
                cityState: '',
                countryZipcode: '',
            },
            saleLevelIrmcheck: [],
            saleIrmStatus: false,
            irmUpdateonce: false,
            buynowItemReceiptValue : '',
            pickupCheckBox: false,
            itemIrm: [],
            suspendedErrorMessage: '',
            confirmBuyNowIrm: true,
            closeBuyNowIrmButton : true,
            payPalMessage: false,

            isreturnassurance: false,
            isdeliveryguarantee: false,
            deliveryInfoModal: false,
            returnAssuranceInfoModal: false,
            bidConfirmModalType: "",
            seelData: '',
            showSeelLoading: false,
            showSeelErrorMessage: '',
            bidderIRMChecked: '',
            raEligibleList: {},
            irmSelected: '',
            seelGDData: '',
            showRAModal: false,
            showGDModal: false,
            dgEligibleList: {},
            showGDSeelLoading: false,
            showGDSeelErrorMessage: '',
            ispremierCredit: false,
            disablePaymentMethod: false,
            suspendList: []
        };

        /* Params data */
        this.userId = this.props.user.id
        this.itemId = this.props?.match?.params?.itemId;
        this.itemTitle = this.props?.match?.params?.itemTitle;
        this.saleId = this.props?.match?.params?.saleId;
        this.previousItemId = false;
        this.nextItemId = false;
        this.bidHistoryInterval = null;
        this.eventSource = null;

        this.updateTimeInterval = null;
        this.updateDetailTimeOut = null;
        this.firstTimeUpdate = false;
        this.showSoftClose = false;
        this.softCloseUpdated = false;
        this.totalItems = 0;
        this.itemsList = [];
        this.activeItemIndex = 0;
        this.activePathName = '';

        this.previousState = this.state;
        this.sidebarthumb = {};

        // this.starttime = 0;
        // this.endtime = 0;
        this.timeoutInterval = null;
        this.conditionsData = [
            {
              condition: "NEW",
              description: "Items show no signs of being worn and include tags, packaging, etc."
            },
            {
              condition: "LIKE NEW",
              description: "Items are clearly unused, but tags are not attached, packaging missing, etc."
            },
            {
              condition: "VERY GOOD",
              description: "Items show minor signs of wear. Example- shoes may have light scuffing on the soles, light scratches."
            },
            {
              condition: "GOOD",
              description: "Items show moderate signs of wear, moderate scuffing or scratches"
            },
            {
              condition: "FAIR",
              description: "Heavy wear, scratches, etc."
            }
          ];
          
    }

    componentDidMount() {
        this.pageRender();
        document.addEventListener('visibilitychange', this.handleTabChange);
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "itemview" } });
        enablePreviousState();
        window.addEventListener('resize', this.getwindowwidth);
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.getBidHistory();
            this.getMessageList();
            this.getIrmDetails();
        }
        document.addEventListener('visibilitychange', this.handleTabChange);
    }

    pageRender = () => {
        try {
            this.requiredData();
            this.activePathName = this.props?.location?.state && this.props?.location?.state?.searchPath ? Buffer.from(this.props?.location?.state?.searchPath, "base64").toString("ascii") : null;
            if (this.activePathName) {
                const stateData = this.activePathName.includes('wonNotWonMaintain') ? this.activePathName : `${SaleCardView}${this.activePathName}`;
                const itemsTemp = JSON.parse(sessionStorage.getItem(stateData));
                this.activeItemIndex = JSON.parse(sessionStorage.getItem(`ActiveItemIndex${this.activePathName}`));
                this.itemsList = itemsTemp.itemsList;
                this.totalItems = this.itemsList.length - 1;
                this.previousItemId = this.activeItemIndex > 0;
                this.nextItemId = this.totalItems > this.activeItemIndex;
            }
        } catch (error) {
            this.requiredData();
        }
    }

    confirmBuyNowIrm = () => {
        if(this.state.bidderIRMChecked != "" || this.state.bidderIRMChecked != null) {
            this.getPlaceBidSeelData("buynow");
        }
        this.setState({
            confirmBuyNowIrm: false,
            closeBuyNowIrmButton : false,
            payPalMessage: true,
        
        })
    } 
    closeBuyNowConfirm = () => {
        this.setState({
            paymentSelectionModal: false,
            paymentError: false,
            payPalMessage: false,
            buynowItemReceiptValue : '',
            confirmBuyNowIrm : true,
            closeBuyNowIrmButton: true,
            showSeelErrorMessage: '',
            showSeelLoading: false,
            showRAModal: false,
            showGDModal: false,
            showGDSeelLoading: false,
            showGDSeelErrorMessage: ''
        })

    }

    requiredData = () => {
        this.getRequiredDetails();
        this.getMessageList();
        this.getUtc();
    }

    onApprove(data, actions) {
        this.setState({
            paymentSuccess: true,
            paymentUpdated: false
        });

        const item_id = this.itemId;
        const invoicenumber = this.props.payPalPage.moreDetails.invoicenumber;

        const postData = {
            "data": {
                "referencenumber": data['orderID'],
                "amount": this.state.totalPriceForBuyNow.total,
                "credit": 1,
                "paymentmode": "paypal",
                "paymentreference": data['payerID'],
                "status": "completed",
                "partialpayment": 0,
                "buyerid": this.props.user.id,
                "paypal": data,
                "rastatus": this.state.isreturnassurance,
                "gdstatus": this.state.isdeliveryguarantee
            }
        };

        if (this.state.buynowItemReceiptValue) {
            postData.data["invoiceitemreceiptmethod"] = this.state.buynowItemReceiptValue;
        }
    
        if (item_id) {
            postData.data["comments"] = `${item_id}`;
            postData.data["itemid"] = item_id;
        }

      

        this.setState({
            postData: postData,
        });
        this.props.history.push({pathname:'/payment', state: {payPalConfig: this.state.postData}, papaypalstatus: true});
    }
    getDescription = (condition) => {
        const foundCondition = this.conditionsData.find(item => item.condition === condition);
        return foundCondition ? foundCondition.description : '';
      }

    createOrder(data, actions) {
        store.dispatch({
            type: 'PAYPAL_PAYMENT_PAGE',
            payload: {
                amount: this.state.totalPriceForBuyNow.total,
                redirectTo: `/my-account/invoice`,
                moreDetails: {
                    itemId: this.itemId,
                    payee: this.state.itemsDetails.paypalemail,
                    description: `Itemid - ${this.itemId}, Sale id - ${this.state.itemsDetails.saleid}`,
                    reference_id: `Itemid - ${this.itemId}`,
                    isshippable: this.state.itemsDetails.isshippable,
                    buy_now_price: this.state.totalPriceForBuyNow.buynowprice,
                    tax_amount: this.state.totalPriceForBuyNow.taxValue,
                    quantity: 1,
                    item_name: this.state.itemsDetails.title,
                    bpAmount: this.state.totalPriceForBuyNow.buyerspremium,
                    tax_on_BPAmount: this.state.totalPriceForBuyNow.taxonbpamount,
                    amount: this.state.totalPriceForBuyNow.buynowprice,
                    total_amount: this.state.totalPriceForBuyNow.total,
                    sku: this.state.itemsDetails.SKU,
                    shipping: this.state.totalPriceForBuyNow.shippingfee,
                    handling: this.state.totalPriceForBuyNow.handlingfee
                }
            }
        });

        const item_id = this.itemId;
        const invoicenumber = this.props.payPalPage.moreDetails?.invoicenumber;
        if (item_id) {
            return actions.order.create({
                purchase_units: [
                    {
                        description: this.props.payPalPage.moreDetails.description,
                        reference_id: this.props.payPalPage.moreDetails.reference_id,
                        amount: {
                            currency_code: "USD",
                            value: parseFloat(this.state.totalPriceForBuyNow.total),
                            breakdown: {
                                item_total: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.total - (this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount + this.state.totalPriceForBuyNow.shippingfee + this.state.totalPriceForBuyNow.handlingfee)).toFixed(2))
                                },
                                shipping: {
                                    currency_code: "USD",
                                    value: parseFloat(this.state.totalPriceForBuyNow.shippingfee)
                                },
                                handling: {
                                    currency_code: "USD",
                                    value: parseFloat(this.state.totalPriceForBuyNow.handlingfee)
                                },
                                tax_total: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount).toFixed(2))
                                }
                            }
                        },
                        payee: {
                            email_address: this.state.itemsDetails.paypalemail
                        },
                        // payment_instruction: {
                        //     disbursement_mode: "INSTANT",
                        //     payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED"
                        // },
                        application_context: {
                            user_action: "PAY_NOW",  // Button name, can be PAY_NOW or CONTINUE
                        },
                        items: [
                            {
                                name: this.props.payPalPage.moreDetails.item_name,
                                quantity: 1,
                                sku: this.props.payPalPage.moreDetails.sku,
                                tax: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount).toFixed(2))
                                },
                                unit_amount: {
                                    currency_code: "USD",
                                    value: parseFloat(parseFloat(this.state.totalPriceForBuyNow.total - (this.state.totalPriceForBuyNow.taxValue + this.state.totalPriceForBuyNow.taxonbpamount + this.state.totalPriceForBuyNow.shippingfee + this.state.totalPriceForBuyNow.handlingfee)).toFixed(2))
                                }
                            }
                        ]
                    },
                ],
            }).then(details => {
                const data = {
                    ordernumber: details,
                    itemid: item_id,
                    gateway: "paypal"
                };
                return InvoiceService.createBuynowOrderDetail({ data }).then(orderDetail => {
                    this.setState({ buynowOrderCreated: true, orderDetail: orderDetail.data.data[0] });
                    return details;
                }).catch(error => {
                    if (error.status === 503) {
                        this.serviceDown();
                    } else {
                        this.setState({
                           
                            paymentError: "Oops Something went wrong, please try again or contact CTBids Helpdesk."
                        });
                    }
                    return;
                });
            })

        } else {
            return actions.order.create({
                purchase_units: [
                    {
                        description: this.props.payPalPage.moreDetails.description,
                        reference_id: this.props.payPalPage.moreDetails.reference_id,
                        amount: {
                            value: this.props.payPalPage.amount,
                        },
                        payee: {
                            email_address: this.props.payPalPage.moreDetails.payee
                        },
                        // payment_instruction: {
                        //     disbursement_mode: "INSTANT",
                        //     payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED"
                        // },
                        application_context: {
                            user_action: "PAY_NOW",  // Button name, can be PAY_NOW or CONTINUE
                        }
                    },
                ],
            }).then(details => {
                const data = {
                    ordernumber: details,
                    invoiceid: invoicenumber,
                    gateway: "paypal"
                };
                return InvoiceService.createInvoiceOrderDetail({ data }).then(orderDetail => {
                    this.setState({ invoiceOrderCreated: true, orderDetail: orderDetail.data.data[0] });
                    return details;
                }).catch(error => {
                    if (error.status === 503) {
                        this.serviceDown();
                    } else {
                        this.setState({
                            paymentError: "Oops Something went wrong, please try again or contact CTBids Helpdesk."
                        });
                    }
                    return;
                });
            }).catch(error => {
                this.setState({
                    paymentError: "Payment Processing failed. Please try again or contact Seller directly."
                });
                return;
            });

        }
    }
    onCancel = (data) => {
        if (this.state.invoiceOrderCreated) {
            this.cancelInvoiceOrder().then(res => res).catch(error => error);
        }
        if (this.state.buynowOrderCreated) {
            this.cancelBuynowOrder().then(res => res).catch(error => error);
        }
    }
    cancelBuynowOrder = () => {
        const item_id =  this.itemId;
        return InvoiceService.cancelBuynowOrder(item_id).then(res => res).catch(error => error);
    }

    getSuspendedList = () => {
        let payload = {
            "filter": [
                { "field": "buyerid", "value": this.props.user.id, "op": "=", "join": "AND" },
                { "field": "locationid", "value": this.state.itemsDetails.locationid, "op": "=", "join": "AND" }
            ]
        }
        axios.post(getBuyersUrl(suspendList), payload, getBuyerHeaders()).then(res => {
            this.setState({
                suspendList : res.data.data
            })
        })
    }


    /* Called when the page load */
    getRequiredDetails = () => {

        /**
         *  This condition for handle API call's when click previous & next button.
         *  Just checking current item details with params id. 
         *  Previous details also calling due to component did update. For that this condition using.
         */
        if (this.itemId === this.props?.match?.params?.itemId) {
            /* Getting sale details */
            /* Getting item details */
            /* Get item images list */
            // this.starttime = new Date().getTime();
            // this.getItemDetails().then(response => {
                Promise.all([this.getItemDetails(), this.getItemImages()]).then(responses => {
                    if (responses[0].length == 0) {
                        this.props.history.push("/");
                        return;
                    } else if(!this.itemTitle && responses[0][0].itemseourl) {
                        this.props.history.push(getItemUrl(this.saleId, this.itemId, responses[0][0].itemseourl));
                    }
                    const itemDetailResponse = responses[0][0]
                    const tempImageList = responses[1].length > 0 ? responses[1] : [{ url: image_thumbnail, type: "image" }];
                    const index = tempImageList.findIndex(x => x.isdisplayimage === 1);
                    if (index !== -1 && index !== 0) {
                        let temp = tempImageList[index];
                        tempImageList[index] = tempImageList[0];
                        tempImageList[0] = temp;    
                    }
                    // this.endtime = new Date().getTime();
                    this.setState({
                        ...this.state,
                        // saleDetail: responses[0]['saleDetail'],
                        // locationDetail: responses[0]['locationDetail'],
                        itemsDetails: itemDetailResponse,
                        itemImageList: tempImageList,
                        activeImage: tempImageList[0],
                        noImage: responses[1].length === 0,
                        pageLoading: false,
                        // timeTaken: this.endtime - this.starttime
                    }, () => {
                        this.initialCheck();
                        this.getWatchList();
                        this.getLocationImageList();
                        this.getSuspendedList();
                        this.getSidebarthumb();
                        if (this.state.itemsDetails.itemtypeid === 2) {
                            this.sseEventListener();
                        }
                        if (isAuthorized()) {
                            this.getBidHistory();
                            this.getIrmDetails();
                        } else {
                            this.getCurrentBidValue(true, true);
                        }
                        this.getEligibleCategoryandLocation();
                    });
    
                    const analyticsParam = {
                        'page_title': 'Item-View',
                        'page_path': this.props.location.pathname
                    };
                    // google analytics config for item detail page
                    window.gtag('config', gaID, analyticsParam);
                    if (itemDetailResponse['googlecode']) {
                        window.gtag('config', itemDetailResponse['googlecode'], analyticsParam);
                    }
    
                    trackCustomEvent("ItemView", analyticsParam);
                    const fbpixel = itemDetailResponse?.['fbpixel'];
                    if (fbpixel) {
                        initFbPixel(fbpixel);
                        trackCustomEvent("ItemView", analyticsParam, fbpixel);
                    }
                    ItemsService.addCountAPI(this.itemId).then(Res => Res).catch(err => err);
                }).catch(error => {
                    this.setState({
                        noDataFound: true,
                        pageLoading: false
                    });
                });
            // }).catch(error => {
            //     this.setState({
            //         noDataFound: true,
            //         pageLoading: false
            //     });
            // });        
        }
    }

    // getSaleAndLocationDetails = async () => {
    //     const saleDetailData = {
    //         "sort": [
    //             { "field": "title", "direction": "asc" }
    //         ],
    //         "field": [
    //             'id', 'locationid', 'contactemail', 'endtime', 'paymentinfo', 'pickupinfo', 'provenance', 'shippinginfo', 'status',
    //             'termsandconditions', 'title'
    //         ]
    //     };

    //     return new Promise((resolve, reject) => {
    //         SalesService.getSaleDetails(this.saleId, saleDetailData).then(saleDetail => {

    //             /* Getting location details */
    //             LocationService.getLocationDetails(saleDetail.data.data[0].locationid, { data: {} }).then(
    //                 locationDetail => {

    //                     // if (!locationDetail.data.data[0]) {
    //                     //     throw new Error("Location detail missing");
    //                     // }

    //                     resolve({saleDetail: saleDetail.data.data[0], locationDetail: locationDetail.data.data[0]});
    //                 }
    //             ).catch((error) => {
    //                 // TODO: Error message handle
    //                 reject(error);
    //             });
    //         }).catch((error) => {
    //             // TODO: Error message handle
    //             reject(error);
    //         });
    //     });
    // };
    
    getItemDetails = async (value) => {
        if (value) {
            this.setState({
                placebidLoading: true,
            })
        }
        const itemsDetailsGet = {
            "sort": [
                { "field": "title", "direction": "asc" }
            ],
            "filter": this.itemTitle ? [
                { "field": "itemseourl", "value": this.itemTitle, "op": "=", "join": "AND" },
                { "field": "saleid", "value": this.saleId, "op": "=", "join": "AND" },
                { "field": "itemid", "value": this.itemId, "op": "=", "join": "AND" }] : [
                { "field": "saleid", "value": this.saleId, "op": "=", "join": "AND" },
                { "field": "itemid", "value": this.itemId, "op": "=", "join": "AND" }
            ]
        };

        return new Promise((resolve, reject) => {
            ItemsService.getItemDetails(this.itemId, itemsDetailsGet).then(
                itemsDetail => {
                    resolve(itemsDetail.data.data);
                    let valuecheck = JSON.parse(itemsDetail.data?.data[0]?.itemreceiptmethod);
                    const irmvalue = valuecheck ? Object.keys(valuecheck).filter(key => valuecheck[key] === true) : ['pickup'];
                    this.setState({
                        itemIrm: irmvalue,
                        placebidLoading: false,
                    })
                }
            ).catch((error) => {
                // TODO: Error message handle
                this.setState({
                    placebidLoading: false,
                })
                reject(error);
            });
        });
    }

    getItemImages = async () => {
        const imageListPostData = {
            "filter": [{ "field": "itemid", "value": this.itemId, "op": "=", "join": "AND" }],
            "field": ["id", "name", "type", "url", "itemid", "isdisplayimage", "displayorder", "thumbnailurl"],
            "sort": [{ "field": "displayorder", "direction": "asc" }],
            "page": { "size": 1000 }
        };

        return new Promise((resolve, reject) => {
            ItemsService.getItemImagesList(imageListPostData).then(imageList => {
                resolve(imageList.data.data);
            }).catch(error => {
                reject(error);
            });
        });
        
    }

    setActiveImage = (image, index) => {
        this.setState({
            activeImage: image,
            activeImageIndex: index
        }, () => {
            this.getVideoThumbnail();
        });
    }

    /**
     * Called when up or down button click
     * 
     * @param {string} direction Either Up or Down
     * 
     */
    ScrollHandle = (direction) => {

        /* Scroll up or down with animation */
        direction === 'Down' ? this.imageScrollRef.current.scrollTo({
            top: (this.imageScrollRef.current.scrollTop + 150),
            behavior: 'smooth'
        }) : this.imageScrollRef.current.scrollTo({
            top: (this.imageScrollRef.current.scrollTop - 150),
            behavior: 'smooth'
        });

        /* Disable buttons based on scroll */
        setTimeout(() => {
            const scrollContent = this.imageScrollRef.current;
            this.setState({
                descriptionScrollButtons: {
                    disableTop: scrollContent.scrollTop === 0,
                    disableDown: scrollContent.clientHeight <= scrollContent.scrollTop
                }
            });
        }, 500);

    }

    /* Called when buy now button click */
    buyNow = () => {
        if (isAuthorized()) {
            this.shippingAddressCheck();
            this.setState({
                buyNowConfirmModal: true,
                buyNowModalHandle: { message: null, loading: true }
            }, () => {
                ItemsService.getItemBuyNowPrice(this.itemId).then(
                    res => {
                        const data = res.data.data;
                        const buyNow = data.buynowprice ? data.buynowprice : 0;
                        const shippingfee = data.shippingfee ? data.shippingfee : 0;
                        const handlingfee = data.handlingfee ? data.handlingfee : 0;
                        const applytaxonbp = data.applytaxonbp ? data.applytaxonbp : 0;
                        const taxonbpamount = data.taxonBPAmount ? data.taxonBPAmount : 0;
                        const buyerspremiumValue = data.buyerspremiumamount;
                        const taxValue = data.taxamount;
                        const total = data.amount ? data.amount : parseFloat(buyNow + buyerspremiumValue + taxValue + shippingfee + handlingfee + taxonbpamount).toFixed(2);

                        this.setState({
                            totalPriceForBuyNow: {
                                buynowprice: buyNow,
                                buyerspremium: buyerspremiumValue,
                                taxValue: taxValue,
                                handlingfee: handlingfee,
                                shippingfee: shippingfee,
                                applytaxonbp: applytaxonbp,
                                taxonbpamount: taxonbpamount,
                                total: total,
                            },
                            buyNowModalHandle: { message: null, loading: false }
                        });
                    }
                ).catch(
                    error => {
                        if (error.status === 401) {
                            const encoded = Buffer.from(this.props.history.location.pathname).toString("base64");
                            logout(this.props.history, true, encoded);
                            store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                            this.setState({
                                buyNowConfirmModal: false,
                                buyNowModalHandle: { message: null, loading: false }
                            });
                        } else {
                            this.setState({
                                buyNowModalHandle: { message: error.message, loading: false }
                            });
                        }
                    }
                );
            });

        } else {
            this.signIn();
        }
        if(this.watching()){
            let dataLayerData = {
                'event': 'buy_now',
                'title': this.state.itemsDetails.title
            }
            addDataLayer(dataLayerData)
        }
    }

    closeConfirmModal = () => {
        this.setState({
            totalPriceForBuyNow: { buynowprice: 0, buyerspremium: 0, taxValue: 0, shippingfee: 0, total: 0, applytaxonbp: 0, taxonbpamount: 0, handlingfee: 0 },
            placeBidValue: { total: 0, currentValue: 0, buyerspremiumValue: 0 },
            buyNowConfirmModal: false,
            bidConfirmModal: false,
            askAQuestion: false,
            bidError: null,
            bidLoading: false,
            estateTermsConditions: false,
            paymentSelectionModal: false,
            paymentConfirmBtn: false,
            paymentError: false,
            itemReciptModel: false,
            shippingModel:false,
            pickupModel: false,
            suspendedErrorMessage: '',
            deliveryInfoModal: false,
            returnAssuranceInfoModal: false,
            isreturnassurance: false,
            showSeelErrorMessage: '',
            showSeelLoading: false,
            isdeliveryguarantee: false,
            showRAModal: false,
            showGDModal: false,
            showGDSeelLoading: false,
            showGDSeelErrorMessage: '',
            disablePaymentMethod: false
        });
    }

    /* Called when confirm button click */
    confirmBuyNow = (paymentData) => {
        this.setState({
            paymentConfirmLoading: true,
            paymentConfirmBtn: true
        }, () => {
            if (isAuthorized() && paymentData == "autodebit") {
                const data = {
                    "data": {
                        "itemid": this.itemId,
                        "amount": this.state.totalPriceForBuyNow.total,
                        "invoiceitemreceiptmethod": this.state.buynowItemReceiptValue,
                        "rastatus": this.state.isreturnassurance,
                        "gdstatus": this.state.isdeliveryguarantee
                    }
                };
                this.setState({
                    paypalbtnDisabled: true,
                })
                ItemsService.autoDebit(data).then(data => {
                    if(data.data.status.toLowerCase() === 'success'){
                        this.setState({
                            paymentSelectionModal: false,
                            paymentConfirmLoading: false,
                            paymentConfirmBtn: false
                        });
                    }
                    this.props.history.push({pathname:'/payment-autodebit', state: {autoDebitAmount: this.state.totalPriceForBuyNow.total}});
                }).catch((error) => {
                    this.setState({
                        paypalbtnDisabled: false,
                        paymentError: error.message,
                        paymentConfirmBtn: false,
                        paymentConfirmLoading: false
                    })
                });   
            } else if(isAuthorized() && paymentData == "paypal") {
                store.dispatch({
                    type: 'PAYPAL_PAYMENT_PAGE',
                    payload: {
                        amount: this.state.totalPriceForBuyNow.total,
                        redirectTo: `/my-account/invoice`,
                        moreDetails: {
                            itemId: this.itemId,
                            payee: this.state.itemsDetails.paypalemail,
                            description: `Itemid - ${this.itemId}, Sale id - ${this.state.itemsDetails.saleid}`,
                            reference_id: `Itemid - ${this.itemId}`,
                            isshippable: this.state.itemsDetails.isshippable,
                            buy_now_price: this.state.totalPriceForBuyNow.buynowprice,
                            tax_amount: this.state.totalPriceForBuyNow.taxValue,
                            quantity: 1,
                            item_name: this.state.itemsDetails.title,
                            tax_on_BPAmount: this.state.totalPriceForBuyNow.taxonbpamount,
                            bpAmount: this.state.totalPriceForBuyNow.buyerspremium,
                            amount: this.state.totalPriceForBuyNow.buynowprice,
                            total_amount: this.state.totalPriceForBuyNow.total,
                            sku: this.state.itemsDetails.SKU,
                            shipping: this.state.totalPriceForBuyNow.shippingfee,
                            handling: this.state.totalPriceForBuyNow.handlingfee
                        }
                    }
                });
                this.props.history.push('/payment');
            } else {
                this.signIn();
            }
        })
    }

    back = () => {
        enablePreviousState();
        if (this.props.onBackClick) {
            this.props.onBackClick();
        } else {
            this.props.history.goBack();
        }
    }

    estateSale = () => {
        removeStateMaintainValue([estateSaleCategory, SaleCardView]).then(res => {
            this.props.history.push(`/estate-sale/${this.state.itemsDetails.saleid}`);
        }).catch(err => console.error(err));
    }

    formatDate = () => {
        return dateTimeFormat(this.state.itemsDetails.itemclosetime);
        // return moment(this.state.itemsDetails.itemclosetime).format('MM/DD/YYYY');
    }

    saleTitleReadMoreHandle = () => {
        this.setState({
            saleTitleReadMore: !this.state.saleTitleReadMore
        })
    }
    setPlacebidValue = async (callSeel=true) => {
        const confirm_amount = this.state.placeBidForm.amount.value;
        const buyerspremium = this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0;
        const buyerspremiumValue = parseFloat((confirm_amount / 100) * buyerspremium).toFixed(2);
        const total = parseFloat(parseFloat(confirm_amount)).toFixed(2);
        this.getItemDetails(true);
        if(callSeel && this.state.bidderCheck && !(parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue)) && (this.state.bidderIRMChecked != "" || this.state.bidderIRMChecked != null) ) {
            this.getSeelDetails();
            this.getSeelGDDetails();
        }

        this.setState({
            bidConfirmModal: true,
            placeBidValue: { total: total, currentValue: confirm_amount, buyerspremiumValue: buyerspremiumValue }
        })
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName, count = null, validControl = "formValid", isCheckBox = false) => {
        let controlError = '';

        if (isCheckBox) {
            event.target.value = event.target.checked;
        }
        /* Decimal value check */
        if (event.target.name === 'amount') {
            event.target.value = event.target.value.replace(/[^0-9.]/g, '')
            let value = event.target.value
            const checkvalue = (value.match(/\./g) || []).length;
            
            if(value.length == 1 && value.includes('.')){
                event.target.value = ''
            }
            if (checkvalue > 1) {
                return;
            }

            if (event.target.value.includes('.') && event.target.value.split('.')[1].length > 2) {
                return;
            }
            if (this.timeoutInterval) {
                clearTimeout(this.timeoutInterval);
            }
            this.timeoutInterval = setTimeout(() => {
                if (event.target.value) {
                    var a = parseFloat(event.target.value).toFixed(2)
    
                    const parts = a.split('.');
    
                    let formattedValue = '';
                    if (parts.length >= 1) {
                        formattedValue += parts[0];
                    }
                    if (parts.length >= 2) {
                        formattedValue += '.' + parts[1].slice(0, 2);
                    }
    
                    const dotCount = (formattedValue.match(/\./g) || []).length;
                    if (dotCount > 1) {
                        const dotIndex = formattedValue.indexOf('.');
                        formattedValue = formattedValue.slice(0, dotIndex + 1) + formattedValue.slice(dotIndex + 1).replace(/\./g, '');
                    }
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            [event.target.name]: {
                                ...this.state[formName][event.target.name],
                                value: formattedValue,
                            }
                        }

                    }, () => {
                        if (this.state.bidConfirmModal) {
                           this.setPlacebidValue(false);
                        }
                    })
    
                }
            }, 2000);
        } else if (event.target.value.indexOf('.') !== -1 && count) {
            if ((event.target.value.length - event.target.value.indexOf('.')) > count) {
                event.target.value = parseFloat(event.target.value).toFixed(count);
            }
        }

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ [validControl]: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ [validControl]: formValid });
                }
            });
    }

    placeBidConfirmModal = async() => {
        if (isAuthorized()) {
            const confirm_amount = this.state.placeBidForm.amount.value;
            const buyerspremium = this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0;
            const buyerspremiumValue = parseFloat((confirm_amount / 100) * buyerspremium).toFixed(2);
            const total = parseFloat(parseFloat(confirm_amount)).toFixed(2);
            await this.getItemDetails(true)
            this.shippingAddressCheck();
            this.setState({
                irmOptionData: this.state.itemIrm,
                itemReceiptValue : this.state.itemReceiptValue == "pickup" ? "pickup" : this.state.itemIrm.includes('pickup') && this.state.itemIrm.length === 1 ? 'pickup' : '',
                itemReciptModel : this.state.itemIrm.length === 0 || !this.state.bidderCheck ?  true : false,
                pickupModel:this.state.itemIrm.includes('pickup') && this.state.itemIrm.length === 1 ? true : false,
                // bidConfirmModal: true,
                placeBidValue: { total: total, currentValue: confirm_amount, buyerspremiumValue: buyerspremiumValue }
            },()=> {
                this.setPlacebidValue();
            });
        } else {
            this.signIn();
        }
        let dataLayerData = {
            'event': 'place_bid',
            'title': this.state.itemsDetails.title,
            'placebidamount': this.state.placeBidForm.amount.value,
        }
        addDataLayer(dataLayerData)
    }

    confirmIrmMethod = () => {
        if(this.state.itemReceiptValue === "shipping" || this.state.itemReceiptValue === "delivery"){
            this.setState({
                shippingModel:  true,
                itemReciptModel: false,
                bidConfirmModal:   false,
            })
        }
        else{

            this.setState({
                itemReciptModel: false,
                shippingModel:  false,
                bidConfirmModal: true
            })
        }
        if(this.state.bidderIRMChecked != "" || this.state.bidderIRMChecked != null) {
            this.getPlaceBidSeelData();
        }
    }

    confirmShippingMethod = () => {
    
        this.setState({
            shippingModel:  false,
            itemReciptModel: false,
            bidConfirmModal:   true,
        }) 

    }
    
    onChangeOption = (event) => {
        this.setState({
            itemReceiptValue: event.target.value,
        })
    }
    onChangeBuynowIrm = (event) => {
        if(event.target.type === 'checkbox' ){
        event.target.value = event.target.checked ? 'pickup' : ''
        }
        this.setState({
            buynowItemReceiptValue : event.target.value,
            pickupCheckBox: event.target.type === 'checkbox' ? event.target.checked : false
        })
    }

    shippingAddressCheck = () => {
        let data = {
            "sort": [{ "field": "shipping", "direction": "desc" }],
             "filter": [
                {
                    "field": "addressisactive",
                    "value": 1,
                    "op": "AND",
                    "join": "="
                },
                {
                    "field": "shipping",
                    "value": 1,
                    "op": "AND",
                    "join": "="
                }
            ],
            "page": { "size": 10 }
        }

        PersonalInfoService.shippingAddressList(data).then(response => {
            let data = response.data.data[0]
            let shippingtoCityDelimiter = data.city && data.state ? ', ' : '';
            let shippingtoCountryDelimiter = data.country && data.zipcode ? ', ' : '';
            this.setState({
                shippingto: {
                    address: (data?.address1 ? data?.address1 + ', ' : '') + (data?.address2 ? data?.address2 + ', ' : ''),
                    cityState: (data?.city ? data?.city : '') + (shippingtoCityDelimiter) + (data?.state ? data?.state : ''),
                    countryZipcode: (data?.country ? data?.country : '') + (shippingtoCountryDelimiter) + (data?.zipcode ? data?.zipcode : ''),
                    
                },
            })
        }).catch(error => {
            this.setState({

            })

        });
    }

    irmValueUpdated = () => {
        if (this.state.itemReceiptValue) {
            const irmData = {
                "data": {
                    "saleid": this.saleId,
                    "itemreceiptmethod": this.state.itemReceiptValue,
                    "itemid": this.itemId
                }
            }
            ItemsService.ItemReceiptAdd(irmData).then(data => {
                let value = data.data.status
            }).catch((error) => {
                this.setState({
                    itemReciptModel: false,
                    shippingModel: false,
                })
            });
        }

    }

    captializeLetter = (data) => {
        const capitalized = data.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }


    signIn = () => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
    }

    /* Called when click confirm place bid */
    confirmPlaceBid = () => {
        this.setState({
            bidError: null,
            bidLoading: true,
        }, () => {
            const data = {
                "data": [{
                    "itemid": this.itemId,
                    "bidprice": parseFloat(parseFloat(this.state.placeBidValue.total).toFixed(2)),
                    "rastatus": this.state.isreturnassurance,
                    "itemreceiptmethod": this.state.itemReceiptValue,
                    "gdstatus": this.state.isdeliveryguarantee
                }]
            };
            ItemsService.placeBid(data).then(
                placeBid => {
                    this.setState({
                        bidError: null,
                        bidLoading: false,
                        placeBidForm: {
                            ...this.state.placeBidForm,
                            amount: {
                                ...this.state.placeBidForm.amount,
                                value: ''
                            }
                        },
                        bidderIRMChecked: this.state.itemReceiptValue ? this.state.itemReceiptValue : this.state.bidderIRMChecked
                    }, () => {
                        this.getBidHistory(true);
                        if(this.state.irmOptionData[0] !== ""){
                            this.irmValueUpdated()
                        }
                    });
                }
            ).catch((error) => {
                if (error.status === 401) {
                    const encoded = Buffer.from(this.props.history.location.pathname).toString("base64");
                    logout(this.props.history, true, encoded);
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    this.setState({
                        bidConfirmModal: false
                    });
                }
                this.setState({
                    bidError: error.message,
                    bidLoading: false,
                })
                // TODO: Error message handle
            });
        });
    }

    /* SSE Event  */
    sseEventListener = () => {
        try {
            // const temp = "item=" + this.itemId;
            let now = moment().format('DD-MM-YYYY-HH-mm-ss');
            now = now ? now.replace(/-/g, '') : Math.floor(100000 + Math.random() * 900000);
            const number = Math.floor(100000 + Math.random() * 900000);
            const clientId = now + number.toString();

            this.eventSource = new EventSource(`${getBuyersUrl(bidsSseEvent)}${clientId}`);
            this.eventSource.onmessage = (event) => this.updateBidValue(event);
            this.eventSource.onopen = (event) => this.postCall(event, clientId);
            this.eventSource.onerror = (event) => console.clear();
        } catch (e) {
            console.error(e);
        }
    }

    postCall = (event, clientId) => {
        const headers = { "Content-Type": "application/json" };
        const PostCall = new SSE(`${getBuyersUrl(bidsSseEventAdd)}${clientId}`, { payload: JSON.stringify({ data: { itemIds: [this.itemId] } }), headers });
        PostCall.stream();
    }

    updateBidValue = (event) => {
        try {
            const data = JSON.parse(event.data);
            if (data.itemIds) {
                if (isAuthorized()) {
                    this.getBidHistory();
                } else {
                    this.getCurrentBidValue();
                }
                this.updateItemDetails();
            }
        } catch (e) {
            console.error(e);
        }

    }

    getBidHistory = (closeConfirm = false) => {
        /* Get Bid History */
        this.setState({
            getCurrentBidValueStatus: "REQUEST"
        }, () => {
            if (this.state.itemsDetails.itemtypeid === 2) {
                ItemsService.getBidHistory(this.itemId).then(
                    responseData => {
                        const bidHistoryData = responseData?.data?.data || {};
                        const bidHistory = bidHistoryData?.bidhistory || [];
                        this.setState({
                            ...this.state,
                            bidHistory,
                            currentBid: bidHistory?.length > 0 ? bidHistory?.[0]?.bidprice : 0,
                            incrementvalue: bidHistoryData?.incrementvalue ? bidHistoryData?.incrementvalue : 1,
                            highestBidder: bidHistory?.length > 0 ? bidHistory?.[0]?.nickname : '-',
                            pageLoading: false,
                            bidHistoryData,
                            getCurrentBidValueStatus: "SUCCESS"
                        }, () => {
                            this.checkbidhistory();
                            this.removeBuyNow();
                        });
                        if (closeConfirm) {
                            this.toasterMessage.current.showMessage({ type: 'success', message: 'Bid Placed Successfully' });
                            this.closeConfirmModal();
                            this.updateItemDetails();
                        }
                    }
                ).catch((error) => {
                    // TODO: Error message handle
                    if (error.status === 401) {
                        const encoded = Buffer.from(this.props.history.location.pathname).toString("base64");
                        logout(this.props.history, true, encoded);
                        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    }
                    this.setState({
                        ...this.state,
                        bidHistory: [],
                        currentBid: 0,
                        highestBidder: '-',
                        pageLoading: false,
                        getCurrentBidValueStatus: "FAILURE",
                        refreshData: error?.status === 401 ? {} : {
                            showModal: true,
                            func: this.getBidHistory,
                            params: [closeConfirm]
                        }
                    }, () => {
                        this.removeBuyNow();
                    });
                    // this.closeConfirmModal();
                });
            } else {
                this.setState({
                    pageLoading: false,
                });
            }
        });
    }

    getCurrentBidValue = (disableLoad = false, retry = false) => {
        this.setState({
            getCurrentBidValueStatus: "REQUEST"
        }, () => {
            const data = {
                "data": {
                    "itemIds": [this.itemId]
                }
            };
            if (this.state.itemsDetails.itemtypeid === 2) {
                ItemsService.getCurrentBidValue(data).then(
                    response => {
                        const currentBidValue = response?.data?.data;
                        this.setState({
                            getCurrentBidValueStatus: "SUCCESS",
                            currentBid: currentBidValue?.length > 0 ? currentBidValue?.[0]?.bidprice : 0,
                            incrementvalue: currentBidValue?.length > 0 ? currentBidValue?.[0]?.incrementvalue : 0,
                        }, () => {
                            this.getUtc();
                            if (disableLoad) {
                                this.setState({
                                    pageLoading: false,
                                });
                            }
                        });
                    }
                ).catch(error => {
                    if (this.state.retryAPI < 2) {
                        this.setState({
                            retryAPI: this.state.retryAPI + 1
                        }, () => {
                            if (retry && this.state.retryAPI < 2) {
                                setTimeout(() => {
                                    this.getCurrentBidValue(disableLoad, retry);
                                }, 3000);
                            } else {
                                const bidFailState = {
                                    getCurrentBidValueStatus: "FAILURE",
                                    refreshData: {
                                        showModal: true,
                                        func: this.getCurrentBidValue,
                                        params: [disableLoad]
                                    }
                                }
                                this.getUtc();
                                if (disableLoad) {
                                    this.setState({
                                        pageLoading: false,
                                        ...bidFailState
                                    });
                                } else {
                                    this.setState({
                                        ...bidFailState
                                    });
                                }
                            }
                        });
                    }
                });
            } else {
                if (disableLoad) {
                    this.setState({
                        pageLoading: false,
                        getCurrentBidValueStatus: "SUCCESS",
                    });
                }
            }
        });
    }

    closeTimeCheck = () => {
        this.setState({
            checkingTime: true,
        }, () => {
            this.updateItemDetails(true);
        });
    }

    updateItemDetails = (doCheck = false) => {
        const itemsDetailsGet = { "sort": [{ "field": "title", "direction": "asc" }] };

        /* Getting item details */
        ItemsService.getItemDetails(this.itemId, itemsDetailsGet).then(
            itemsDetail => {
                const tempData = itemsDetail.data.data[0];
                if (!tempData) {
                    throw new Error('Invalid data')
                };
                if (doCheck) {
                    if (tempData.itemclosesin && tempData.itemclosesin > 0) {
                        this.setState({
                            ...this.state,
                            itemsDetails: tempData,
                            // reduceTime: 0,
                            checkingTime: false,
                            itemClosed: false
                        }, () => {
                            this.firstTimeUpdate = false;
                            this.showSoftClose = false;
                            this.softCloseUpdated = true;
                        });
                    } else {
                        this.setState({
                            checkingTime: false,
                        });
                    }
                } else {
                    this.setState({
                        ...this.state,
                        itemsDetails: tempData,
                        // reduceTime: 0,
                        checkingTime: false,
                        itemClosed: false
                    }, () => {
                        this.firstTimeUpdate = false;
                        this.showSoftClose = false;
                        this.softCloseUpdated = true;
                    });
                }
            }
        ).catch((error) => {
            // TODO: Error message handle
            this.setState({
                checkingTime: false,
                connectionError: true
            });
            this.softCloseUpdated = true;
        });
    }

    askAQuestionModal = () => {
        this.setState({
            askAQuestion: true
        });
    }

    /**
     * 
     * @param {string} direction either Up or Down 
     */
    scrollToItemView = (direction) => {
        const top = direction === 'Up' ? 0 : this.itemViewRef.current.scrollHeight;
        this.itemViewRef.current.scrollTo({ top: top, left: 0, behavior: 'smooth' });
    }

    getUtc = () => {
        this.setState({
            checkingTime: true,
            connectionError: false
        }, () => {
            this.setState({
                commonUTCTime: moment.utc(),
                reduceTime: 0,
                checkingTime: false,
                // notUpdated: false
            }, () => {
                if (this.updateTimeInterval) {
                    clearInterval(this.updateTimeInterval);
                    this.updateTime();
                } else {
                    this.updateTime();
                }
            });
        });
    }

    updateTime = () => {
        this.updateTimeInterval = setInterval(() => {
            this.setState({
                reduceTime: this.state.reduceTime + 1
            }, () => {
                this.countdown();
            });
            console.clear();
        }, 1000);
    }

    countdown = () => {
        const endtime = this.state.itemsDetails.itemclosetime ? this.state.itemsDetails.itemclosetime : this.state.itemsDetails.endtime;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();
        const countdown = getCountDown(endtime, moment.utc().add(2, 'seconds'), false, utcTime);
        this.expiration = countdown.expiration;

        // Get bg color
        const duration_bg_color = getDurationBgColor(endtime, moment.utc().add(2, 'seconds'));

        this.setState({
            ...this.state,
            duration: countdown.diffDuration,
            duration_bg_color: duration_bg_color
        });
    }

    numberDaysInWord = () => {
        const endtime = this.state.itemsDetails.itemclosetime ? this.state.itemsDetails.itemclosetime : this.state.itemsDetails.endtime;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();
        const countdown = getCountDown(endtime, moment.utc().add(2, 'seconds'), false, utcTime);
        const duration = countdown.diffDuration;

        const check = duration.asSeconds() < 2 ? "Item closed" : null;
        const return_value = check ? check : duration.asMinutes() < 3 ? "Item is closing now" : 'Till item closes';

        return return_value;
    }

    betweenCheck = () => {
        const endtime = this.state.itemsDetails.itemclosetime ? this.state.itemsDetails.itemclosetime : this.state.itemsDetails.endtime;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();
        const countdown = getCountDown(endtime, moment.utc().add(2, 'seconds'), false, utcTime);
        const duration = countdown.diffDuration;

        if (countdown.diffDuration.asSeconds() === 1 && !this.showSoftClose) {
            if (this.updateDetailTimeOut) {
                clearInterval(this.updateDetailTimeOut);
            }
            this.updateDetailTimeOut = setTimeout(() => {
                this.showSoftClose = true;
                this.softCloseUpdated = false;
                setTimeout(() => {
                    if (isAuthorized()) {
                        this.getBidHistory();
                    } else {
                        this.getCurrentBidValue();
                    }
                    this.updateItemDetails();
                }, 7000);
            }, 100);
        }

        const return_value = duration.asMinutes() < 1;
        return return_value;
    }

    itmeIsClosed = () => {
        const endtime = this.state.itemsDetails.itemclosetime ? this.state.itemsDetails.itemclosetime : this.state.itemsDetails.endtime;
        const utcTime = this.state.commonUTCTime ? moment.utc(this.state.commonUTCTime).add(this.state.reduceTime, 'seconds') : moment.utc();
        const countdown = getCountDown(endtime, moment.utc().add(2, 'seconds'), false, utcTime);
        const duration = countdown.diffDuration;

        const return_value = duration.asSeconds() < 2;
        this.updatedStatus(return_value);
        return return_value;
    }

    videoPlayModalToggle = () => {
        this.setState({
            videoPlayerModal: !this.state.videoPlayerModal
        })
    }

    bidHistoryModalToggle = () => {
        this.setState({
            bidHistoryModal: !this.state.bidHistoryModal
        })
    }

    readMoreShowAndHide = () => {
        const element = this.readMore.current;
        return element ? element.offsetWidth < element.scrollWidth : false;
    }

    moreSale = () => {
        disablePreviousState();
        // const location = this.state.locationDetail;
        const LocationUrl = this.state.itemsDetails.locationcode ? `/estate-sales/${this.state.itemsDetails.locationstatecode}/${this.state.itemsDetails.locationcode}` : `/estate-sales/${this.state.itemsDetails.locationstatecode}`;
        this.props.history.push(LocationUrl);
    }

    watch = (event) => {
        event.stopPropagation();
        const itemId = this.state.itemsDetails.id;
        this[`buttonDOM`].blur();
        if (isAuthorized()) {
            const index = this.state.watch.findIndex(x => x.itemid === itemId);
            if (index !== -1) {
                const removeData = {
                    "data": {
                        "itemIds": [itemId]
                    }
                };
                ItemsService.removeFromWatch(removeData).then(
                    response => {
                        this.getWatchList();
                    }
                ).catch((error) => {
                    this.getWatchList();
                });
            } else {
                const addData = {
                    "data": [
                        {
                            "itemid": itemId
                        }
                    ]
                }
                ItemsService.addToWatch(addData).then(
                    response => {
                        this.getWatchList();
                    }
                ).catch((error) => {
                    this.getWatchList();
                });
            }
        } else {
            this.signIn();
        }
        let dataLayerData = {
            'event': 'watch',
            'title': this.state.itemsDetails.title
        }
        addDataLayer(dataLayerData)
    }

    getWatchList = () => {
        if (isAuthorized()) {
            const data = {
                "sort": [{ "field": "id", "direction": "desc" }],
                "filter": [{ "field": "itemid", "value": this.state.itemsDetails.id, "op": "=", "join": "AND" }],
                "page": { "size": 50 }
            };
            ItemsService.getWatchList(data).then(
                response => {
                    this.setState({
                        watch: response.data.data
                    });
                }
            ).catch(error => {

            });
        }
    }

    getLocationImageList = () => {
        const locationImageData = { "filter": [{ "field": "locationid", "value": this.state.itemsDetails.locationid, "op": "=", "join": "AND" }] }
        LocationService.getLocationImagesList(locationImageData).then(
            locationImage => {
                this.setState({
                    locationImage: locationImage.data.data
                });
            }
        ).catch(error => {

        });
    }
    watching = (items) => {
        const itemId = this.state.itemsDetails.id;
        return this.state.watch.filter(x => x.itemid === itemId).length > 0;
    }

    removeBuyNow = () => {
        const currentBid = this.state.currentBid;
        const buyNowPrice = this.state.itemsDetails.buynowprice;
        const getAmount = (buyNowPrice / 100) * 75;
        const removeBuyNow = this.state.itemsDetails.itemtypeid < 3 ? getAmount <= currentBid : false;
        this.setState({
            removeBuyNow: this.state.itemsDetails.itemstatus !== "Ready" ? true : removeBuyNow
        });
    }
    profileComplete = () => {
        this.props.history.push(`/my-account/my-info/personal-info`,{
            previouspath : this.props.location.pathname,
            name:"bidscreen"
        });
    }

    paymentComplete = () => {
        this.props.history.push(`/my-account/my-info/payment-methods/add`, {
            previouspath : this.props.location.pathname,
            name:"bidscreen"
        });
    }

    getMessageList = () => {
        const data = {
            "page": {
                "size": 10
            },
            // "field": ["id", "message", "ispublic", "itemid", "buyerid", "messagereply", "buyername", "isdeleted"],
            "filter": [
                { "field": "itemid", "value": parseInt(this.itemId), "op": "=", "join": "AND" },
                // { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" },
                // { "field": "read", "value": 0, "op": "=", "join": "AND" },
            ]
        };
        ItemsService.getMessageList(data).then(
            response => {
                const temp = response.data.data;
                temp.map((reply)=>{
                    if ( reply['reply'].length > 0 ) {
                        reply['reply'] = reply['reply'];
                    } else {
                        reply['reply'] = [];
                    }
                })
                this.setState({
                    messageList: temp
                });
            }
        ).catch(error => {

        });
    }

    sendMessage = () => {
        this.setState({
            messageLoading: true
        }, () => {
            const messageForm = this.state.messageForm;
            const data = {
                "message": messageForm.message.value,
                "itemid": this.itemId,
                "buyerid": this.props.user.id,
                "ispublic": messageForm.isPublic.value === "false" ? 1 : 0,
                "selleremail": this.state.itemsDetails.contactemail,
                "subject": "Question regarding listing with title " + this.state.itemsDetails.title,
            };
            ItemsService.sendMessage({ data }).then(
                response => {
                    this.setState({
                        messageLoading: false,
                        messageFormValid: false
                    });
                    this.closeConfirmModal();
                    this.getMessageList();
                }
            ).catch(error => {
                if(error.status === 400) {
                    this.setState({
                        messageLoading: false,
                        suspendedErrorMessage: error.message,
                        messageFormValid: false
                    });
                    // this.closeConfirmModal();
                }                
            });
        });
    }

    getReservePriceMet = () => {
        const details = this.state.itemsDetails;
        const reserveprice = details.reserveprice;
        let message = "";
        let bgColor = "text-danger";
        if (reserveprice && reserveprice > 0) {
            if (this.state.currentBid >= reserveprice) {
                message = "Reserve Price Met";
                bgColor = "text-buy-now-color";
            } else {
                message = "Reserve Price Not Met";
            }
        }
        return { message, bgColor };
    }

    /* Called when scroll content */
    handleScroll = (event) => {
        try {
            this.setState({
                isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                pageClientWidth: this.itemViewRef.current.clientWidth
            });
        } catch (e) {
            this.setState({
                isVisible: false
            });
        }
    };

    moveMagnifier = (e) => {
        if (!this.state.noImage) {
            let pos, x, y;
            const zoom = 4;

            const img = this.magnifierImage.current;
            const glass = this.magnifier.current;

            glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";

            const bw = 3;
            const w = glass.offsetWidth / 2;
            const h = glass.offsetHeight / 2;

            /*prevent any other actions that may occur when moving over the image*/
            e.preventDefault();

            /*get the cursor's x and y positions:*/
            pos = this.getCursorPos(e);
            x = pos.x;
            y = pos.y;

            /*prevent the magnifier glass from being positioned outside the image:*/
            if (x > img.width - (w / zoom)) { x = img.width - (w / zoom); }
            if (x < w / zoom) { x = w / zoom; }
            if (y > img.height - (h / zoom)) { y = img.height - (h / zoom); }
            if (y < h / zoom) { y = h / zoom; }

            /*set the position of the magnifier glass:*/
            glass.style.left = (x - w) + "px";
            glass.style.top = (y - h) + "px";

            /*display what the magnifier glass "sees":*/
            glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
        }
    }

    getCursorPos = (e) => {
        let a, x = 0, y = 0;

        const img = this.magnifierImage.current;

        e = e || window.event;

        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();

        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;

        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
    }

    toggleMagnifier = (event, value, flag) => {
        if (flag === 'enter' && !this.state.magnifierHide) {
            this.setState({
                magnifierHide: value
            });
        } else {
            this.setState({
                magnifierHide: value
            });
        }
    }

    handleTabChange = () => {
        if (document.hidden) {
            // tab is now inactive // temporarily clear timer using clearInterval() / clearTimeout()
        } else {
            // tab is active again // restart timers
            if (isAuthorized()) {
                handleToken().then(Res => Res).catch(Err => Err);
            }
            this.getUtc();
        }
    }


    controlClickEvent = () => {
        showAndHideJiraButton(true);
        // const media = this.state.activeImage;
        // if (media.type === "image") {
        if (window.innerWidth > 1040) {
            this.setGalleryModalToggle(!this.state.noImage);
        }
        // } else {
        //     this.videoPlayModalToggle();
        // }
    }

    setActiveImageForGalleryView = (media, index) => {
        this.setState({
            galleryMedia: {
                ...this.state.galleryMedia,
                isZoomed: false,
                activeImage: JSON.parse(JSON.stringify(media)),
                styles: JSON.parse(JSON.stringify(this.defaultGalleryStyle)),
                activeImageIndex: index
            }
        });
    }

    closeZoom = () => {
        this.setState({
            galleryMedia: {
                ...this.state.galleryMedia,
                isZoomed: false,
                styles: JSON.parse(JSON.stringify(this.defaultGalleryStyle))
            }
        });
    }

    toggleZoom = () => {

        const divHeight = this['galleryMedia'].clientHeight;
        const originalHeight = this['galleryImage'].naturalHeight;
        const divWidth = this['galleryMedia'].clientWidth;
        const originalWidth = this['galleryImage'].naturalWidth;
        const imageHeight = originalHeight > divHeight ? "unset" : `${originalHeight + (originalHeight / 2) + 200}px`;
        const imageTop = originalHeight > divHeight ? "0px" : "unset";

        const styles = {
            maxHeight: !this.state.galleryMedia.isZoomed ? 'unset' : '100%',
            height: this.state.galleryMedia.isZoomed ? 'unset' : imageHeight,
            width: 'unset',
            cursor: !this.state.galleryMedia.isZoomed ? 'zoom-out' : 'zoom-in',
            position: 'absolute',
            top: `${!this.state.galleryMedia.isZoomed ? imageTop : 'unset'}`,
        };

        this.setState({
            galleryMedia: {
                ...this.state.galleryMedia,
                isZoomed: !this.state.galleryMedia.isZoomed,
                styles: styles,
                adjustHeight: originalHeight > divHeight,
                adjustWidth: originalWidth > divWidth
            }
        });
    }

    setGalleryModalToggle = (flag) => {
        showAndHideJiraButton(flag);
        this.setState({
            galleryModal: flag,
            galleryMedia: {
                ...this.state.galleryMedia,
                isZoomed: false,
                activeImage: JSON.parse(JSON.stringify(this.state.activeImage)),
                styles: JSON.parse(JSON.stringify(this.defaultGalleryStyle)),
                activeImageIndex: JSON.parse(JSON.stringify(this.state.activeImageIndex))
            }
        });
    }

    nextImage = () => {
        const itemImageList = JSON.parse(JSON.stringify(this.state.itemImageList));
        const activeImageIndex = this.state.galleryMedia.activeImageIndex;
        if (activeImageIndex + 1 < itemImageList.length) {
            this.setState({
                galleryMedia: {
                    ...this.state.galleryMedia,
                    activeImage: JSON.parse(JSON.stringify(itemImageList[activeImageIndex + 1])),
                    styles: JSON.parse(JSON.stringify(this.defaultGalleryStyle)),
                    activeImageIndex: activeImageIndex + 1,
                    isZoomed: false
                }
            })
        }
    }

    previousImage = () => {
        const itemImageList = JSON.parse(JSON.stringify(this.state.itemImageList));
        const activeImageIndex = this.state.galleryMedia.activeImageIndex;
        if (activeImageIndex + 1 > 1) {
            this.setState({
                galleryMedia: {
                    ...this.state.galleryMedia,
                    activeImage: JSON.parse(JSON.stringify(itemImageList[activeImageIndex - 1])),
                    styles: JSON.parse(JSON.stringify(this.defaultGalleryStyle)),
                    activeImageIndex: activeImageIndex - 1,
                    isZoomed: false
                }
            })
        }
    }

    getButtonDisable = (direction) => {
        let res = false;
        if (direction === 'next') {
            res = this.state.itemImageList.length === this.state.galleryMedia.activeImageIndex + 1;
        } else {
            res = this.state.galleryMedia.activeImageIndex === 0;
        }
        return res;
    }

    getwindowwidth = () => {
        this.setState({
            windowWidth: window.innerWidth,
            pageClientWidth: this.itemViewRef.current.clientWidth
        });
    }


    initialCheck = () => {
        if (isAuthorized()) {
            ItemsService.getBidHistory(this.itemId).then(
                res => {
                    const response = res.data.data;
                    if (response.bidstatus && response.bidstatus === "Closed") {
                        this.setState({
                            itemClosed: true,
                            nextButtonClicked: false,
                            previousButtonClicked: false
                        }, () => {
                            this.showSoftClose = true;
                            this.softCloseUpdated = true;
                        });
                    } else {
                        this.setState({
                            nextButtonClicked: false,
                            previousButtonClicked: false
                        });
                    }
                }
            ).catch(error => {
                this.setState({
                    nextButtonClicked: false,
                    previousButtonClicked: false
                });
            });
        } else {
            const data = {
                "data": {
                    "itemIds": [this.itemId]
                }
            }
            ItemsService.getCurrentBidValue(data).then(
                res => {
                    const response = res.data.data[0];
                    if (response.bidstatus && response.bidstatus === "Closed") {
                        this.setState({
                            itemClosed: true,
                            nextButtonClicked: false,
                            previousButtonClicked: false
                        }, () => {
                            this.showSoftClose = true;
                            this.softCloseUpdated = true;
                        });
                    } else {
                        this.setState({
                            nextButtonClicked: false,
                            previousButtonClicked: false
                        });
                    }
                }
            ).catch(error => {
                this.setState({
                    nextButtonClicked: false,
                    previousButtonClicked: false
                });
            });
        }
    }

    getVideoThumbnail = () => {
        if (this.state.activeImage.type !== "image") {
            generateVideoThumbnails(this.state.activeImage.url, 10).then(thumbnailArray => {
                this.setState({
                    thumbnailArray
                });
            });
        }

    }
    getSidebarthumb = () => {
        if (!this.state.noImage) {
            this.state.itemImageList.forEach(async (media) => {
                if (media.type === "video") {
                    const thumb = await generateVideoThumbnails(media.url, 10);
                    this.sidebarthumb[media.id] = thumb[0];
                }
            });
        }
    }
    /**
     * To check item closed in backend.
     * 
     * @param {boolean} flag to call api
     * 
     * @param {boolean} forceUpdate To call every 5 secs once API
     */
    updatedStatus = (flag, forceUpdate = false, dontUpdate = false) => {
        if (flag) {
            if (!this.firstTimeUpdate || forceUpdate) {
                this.firstTimeUpdate = true;
                if (isAuthorized()) {
                    ItemsService.getBidHistory(this.itemId).then(
                        res => {
                            const response = res.data.data;
                            if ('bidstatus' in response) {
                                if (response.bidstatus) {
                                    this.setState({
                                        itemClosed: true
                                    }, () => {
                                        this.showSoftClose = true;
                                        this.softCloseUpdated = true;
                                    });
                                } else {
                                    setTimeout(() => {
                                        this.showSoftClose = true;
                                        this.updatedStatus(true, true);
                                    }, 5000);
                                }
                            } else {
                                this.setState({
                                    itemClosed: true
                                }, () => {
                                    this.showSoftClose = true;
                                    this.softCloseUpdated = true;
                                });
                            }
                        }
                    ).catch(
                        error => {
                            this.setState({
                                itemClosed: true
                            }, () => {
                                this.showSoftClose = true;
                                this.softCloseUpdated = true;
                            });
                        }
                    );
                } else {
                    const data = {
                        "data": {
                            "itemIds": [this.itemId]
                        }
                    }
                    ItemsService.getCurrentBidValue(data).then(
                        res => {
                            const response = res.data.data[0];
                            if ('bidstatus' in response) {
                                if (response.bidstatus) {
                                    this.setState({
                                        itemClosed: true
                                    }, () => {
                                        this.showSoftClose = true;
                                        this.softCloseUpdated = true;
                                    });
                                } else {
                                    setTimeout(() => {
                                        this.showSoftClose = true;
                                        this.updatedStatus(true, true);
                                    }, 5000);
                                }
                            } else {
                                this.setState({
                                    itemClosed: true
                                }, () => {
                                    this.showSoftClose = true;
                                    this.softCloseUpdated = true;
                                });
                            }
                        }
                    ).catch(
                        error => {
                            this.setState({
                                itemClosed: true
                            }, () => {
                                this.showSoftClose = true;
                                this.softCloseUpdated = true;
                            });
                        }
                    );
                }
            }
        }
    }

    checkItClosedInBE = () => {
        let res = "Soft close in progress";
        if (this.showSoftClose && this.softCloseUpdated) {
            res = this.state.itemClosed ? "Item closed" : "Soft close in progress"
        }
        return res;
    }

    componentWillUnmount() {
        // clearInterval(this.bidHistoryInterval);
        window.removeEventListener('resize', this.getwindowwidth);
        if (this.eventSource) {
            this.eventSource.close();
        }
        if (this.updateTimeInterval) {
            clearInterval(this.updateTimeInterval);
            this.updateTime();
        }
        document.removeEventListener('visibilitychange', this.handleTabChange);
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }


    onCloseSomethingWentWrongModal = () => this.setState({
        refreshData: {}
    })


    onRefreshSomethingWentWrongModal = () => {
        const refreshFunction = this.state.refreshData?.func;
        const params = this.state.refreshData?.params;
        if (typeof refreshFunction === 'function' && Array.isArray(params)) {
            refreshFunction(...params)
        }
        this.onCloseSomethingWentWrongModal();
    }


    onImageLoad = (event) => {
        const imgWidth = event.target.naturalWidth;
        const imgHeight = event.target.naturalHeight;
        let imgCropWidth = 0;
        let imgCropHeight = 0;
        const container = this.imageContainer.current;
        const { width, height } = container.getBoundingClientRect();
        if (imgWidth > imgHeight) {
            imgCropWidth = width;
            imgCropHeight = imgHeight / imgWidth * imgCropWidth;
        } else {
            imgCropHeight = height;
            imgCropWidth = imgWidth / imgHeight * imgCropHeight;
        }
        this.setState({
            imgCropWidth, imgCropHeight
        });
    }

    onPreviousNextClick = (isPrevious) => {
        const index = isPrevious ? this.activeItemIndex - 1 : this.activeItemIndex + 1;
        const item = this.itemsList[index];
        const itemid = item.id ? item.id : item.itemid;
        sessionStorage.setItem(`ActiveItemIndex${this.activePathName}`, index);
        this.props.history.replace({ pathname: getItemUrl(item.saleid, itemid, item.itemseourl), state: { searchPath: Buffer.from(this.activePathName).toString("base64") } });
        // this.props.history.replace(`/estate-sale/${item.saleid}/item/${item.id}`);
        this.setState({
            // ...this.previousState,
            nextButtonClicked: !isPrevious,
            previousButtonClicked: isPrevious
        }, () => {
            setTimeout(() => {
                this.pageRender();
            }, 500);
        });
        // this.forceUpdate();
    }

    getCloseinDatetime = (dateTime) => {
        if(dateTime) {
            const formatedDate = moment.utc(dateTime).local();
            let returnValue = formatedDate.format('MM/DD/YYYY hh:mm:ss A');
            let timeZone = moment.tz(moment.tz.guess()).zoneAbbr();

            return `${returnValue} ${timeZone}`;
        } else {
            return '- - -';
        }      
    }

    showTermsAndCondition = () => {
        this.setState({ 
            expandTerms: !this.state.expandTerms,
            estateTermsConditions: true
        })
    }

    handleCloseTerms = () => {
        this.setState({
            estateTermsConditions: false
        })
    }

    confirmPaymentSelection = async (value) => {
        this.setState({
            buynowLoading: true,
        })
        await this.getItemDetails()
        var currentDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        const cardData = { 
            "field": ["id"],
            "filter": [
                {"field": "isdefault", "value": 1, "op": "=", "join": "AND"},
                {"field": "cardexpirydate", "value": currentDate, "op": ">", "join": "OR"},
                {"field": "cardtype", "value": "Paypal", "op": "=", "join": "OR"}
            ]
        }
        ItemsService.autoDebitVaultList(cardData).then(response=>{
            if(response.data.status.toLowerCase() == "success"){
                if(response.data.data.length > 0){
                    this.setState({
                        buynowLoading: false,
                        buyNowConfirmModal: false,
                        paymentSelectionModal: true
                    })
                } else {
                    // this.confirmBuyNow("paypal")
                    this.setState({
                        buynowLoading: false,
                        buyNowConfirmModal: false,
                        paymentSelectionModal: true,
                        disablePaymentMethod: true
                    })
                }
            }
        }).catch(()=>{
            this.confirmBuyNow("paypal")
            this.setState({
                buynowLoading: false,
            })
        })
    }

    handleClose = () => {
        this.setState({
            paymentSelectionModal: false,
            paymentError: false,
            payPalMessage: false,
            buynowItemReceiptValue : '',
            confirmBuyNowIrm : true,
            closeBuyNowIrmButton: true,
            isreturnassurance: false,
            showSeelErrorMessage: '',
            showSeelLoading: false,
            isdeliveryguarantee: false,
            showRAModal: false,
            showGDModal: false,
            showGDSeelLoading: false,
            showGDSeelErrorMessage: ''
        })
    }

    changeDeliveryGuarantee = (event) => {
        this.setState({
            isdeliveryguarantee: event.target.checked,
        })
    }

    changeReturnAssurance = (event) => {
        this.setState({
            isreturnassurance: event.target.checked
        })
    };

    openDeliveryInfoModal = (type) => {
        this.setState({
            bidConfirmModal: false,
            buyNowConfirmModal: false,
            paymentSelectionModal: false,
            deliveryInfoModal: true,
            bidConfirmModalType: type
        })
    }

    openRAInfoModal = (type) => {
        this.setState({
            bidConfirmModal: false,
            buyNowConfirmModal: false,
            paymentSelectionModal: false,
            returnAssuranceInfoModal: true,
            bidConfirmModalType: type
        })
    }

    checkbidhistory(){
        let bidhistorydata =  this.state.bidHistory
        if( bidhistorydata.length > 0 ) {
            bidhistorydata.map((bidderid)=>{
                if(bidderid.buyerid === this.props.user.id){
                    this.setState({
                        bidderCheck: true
                    })
                }
            })
        } else {
            this.setState({
                bidderCheck: false
            })
        }
        
    }

    closeSeelInfoModal = (type) => {
        this.setState({
            bidConfirmModal: this.state.bidConfirmModalType == "Auction" ? true : false,
            paymentSelectionModal: this.state.bidConfirmModalType == "BuyNow" ? true : false,
            [type]: false,
        })
    }

    navigateToUrl = (url) => {
        window.open(url, "_blank");
    }

    returnAssuranceModal = (type) => (
        <>
            {
                // this.props.user.membershipCompleted && (this.state.showGDModal || this.state.showRAModal) && this.props?.user?.suspensionstatus !== 'ALL' ? 
                //     <><div className='d-flex flex-column rounded' style={{ padding: "10px 20px 10px 20px", backgroundColor: "#F5F4FF" }}>
                //         <div className='d-flex flex-column align-items-center justify-content-center'>
                //             <div className='text-center'>As a valued Premier Member on CTBids you are automatically
                //             opted in at no additional charge to you for</div>
                //             { this.state.showRAModal ? <><div className='mt-2 d-flex'>
                //                 <img src={`${process.env.PUBLIC_URL}/static/images/MakeItReturnable.png`} alt="" style={{ width: '35px' }} />
                //                 <span className='text-bold f-16' style={{ margin: "0 10px" }}>Make It Returnable <sup>TM</sup></span>
                                
                //                 <img className='clickable' style={{ width: "15px" }} src={`${process.env.PUBLIC_URL}/static/images/info_icon.svg`} alt='info-icon' onClick={() => { this.openRAInfoModal(type); } } />
                                
                //                 <div class="w-10 d-flex justify-content-end custom-control custom-switch" style={{ marginLeft: "30px" }}>
                //                     <input type="checkbox" class="custom-control-input" id="returnassurance" checked={this.state.isreturnassurance} onChange={this.changeReturnAssurance} />
                //                     <label class="custom-control-label" for="returnassurance"></label>
                //                 </div>
                //             </div></> : ''}
                //             { this.state.showGDModal && this.state.showRAModal ? <div>And</div> : ''}
                //             { this.state.showGDModal ? <><div className='mt-2 d-flex'>
                //                 <img src={`${process.env.PUBLIC_URL}/static/images/guarateedDelivery.png`} alt="" style={{ width: '25px' }} />
                //                 <span className='text-bold f-16' style={{ margin: "0 10px" }}>Delivery Guarantee <sup>TM</sup></span>
                                
                //                 <img className='clickable' style={{ width: "15px" }} src={`${process.env.PUBLIC_URL}/static/images/info_icon.svg`} alt='info-icon' onClick={() => { this.openDeliveryInfoModal(type); } } />
                                
                //                 <div class="w-10 d-flex justify-content-end custom-control custom-switch" style={{ marginLeft: "30px" }}>
                //                     <input type="checkbox" class="custom-control-input" id="deliveryguarantee" checked={this.state.isdeliveryguarantee} onChange={this.changeDeliveryGuarantee} />
                //                     <label class="custom-control-label" for="deliveryguarantee"></label>
                //                 </div>
                //             </div></> : ''}
                //             <span className='text-bold'>Provided By <text style={{ color: "blue" }}>seel</text></span>
                //         </div>              
                //     </div></> :
                this.props.user.suspensionstatus != "ALL" && (this.state.showGDModal || this.state.showRAModal) ? 
                <div className='d-flex flex-column rounded' style={{ padding: "10px 20px 10px 20px", backgroundColor: "#F5F4FF" }}>
                    <div className='d-flex justify-content-between'>
                        <b className='f-16' style={{ color: "#637381" }}>Bid with Confidence</b>
                        <span className='text-bold'>Provided By <text style={{ color: "blue" }}>seel</text></span>
                    </div> 
                    { 
                        this.state.showRAModal ? 
                        <div className='d-flex flex-row align-items-center w-100 mt-4'>
                            <div className="w-20 d-flex">
                                <img style={{ width: "70%" }} src={`${process.env.PUBLIC_URL}/static/images/MakeItReturnable.png`} alt='make-it-returnable-icon' />
                            </div>
                            <div className='d-flex flex-column' style={{ width: "80%" }}>
                                <div className='d-flex gap-10 w-100'>
                                    <span className='text-bold f-16'>Make It Returnable <sup>TM</sup></span>
                                    <img style={{ width: "5%" }} src={`${process.env.PUBLIC_URL}/static/images/info_icon.svg`} alt='info-icon' onClick={() => {this.openRAInfoModal(type)}} />
                                </div>
                                <div className='w-100 d-flex flex-row'>
                                    {/* <span className='w-90 text-muted'>For ${this.props.user.membershipCompleted ? "0.00" : this.state.showRAModal ? parseFloat(this.state.seelData?.price.toString()).toFixed(2) : <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img>}, you can add this option to return these item(s) for any reason within 7 days of pickup or shipping.</span> */}
                                    <span className='w-90 text-muted'>For ${this.state.showRAModal ? parseFloat(this.state.seelData?.price.toString()).toFixed(2) : <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img>}, you can add this option to return these item(s) for any reason within 7 days of pickup or shipping.</span>
                                </div>
                            </div>
                            <div class="w-10 d-flex justify-content-end custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="returnassurance" checked={this.state.isreturnassurance} onChange={this.changeReturnAssurance} />
                                <label class="custom-control-label" for="returnassurance"></label>
                            </div>
                        </div> : '' 
                    }
                    { 
                        this.state.showGDModal ? 
                        <div className='d-flex flex-row align-items-center w-100 mt-4'>
                            <div className="w-20 d-flex">
                                <img style={{ width: "55%", marginLeft: "6px" }} src={`${process.env.PUBLIC_URL}/static/images/guarateedDelivery.png`} alt='guarateed-delivery-icon' />
                            </div>
                            <div className='d-flex flex-column' style={{ width: "80%" }}>
                                <div className='d-flex gap-10 w-100'>
                                    <span className='text-bold f-16'>Delivery Guarantee <sup>TM</sup></span>
                                    <img style={{ width: "5%" }} src={`${process.env.PUBLIC_URL}/static/images/info_icon.svg`} alt='info-icon' onClick={() => {this.openDeliveryInfoModal(type)}} />
                                </div>
                                <div className='w-100 d-flex flex-row'>
                                    {
                                        this.props.user.membershipCompleted && this.state.ispremierCredit ? 
                                            <div className='d-flex flex-column text-muted'>
                                                <span className='w-90'>This item is protected against loss, damage & theft as part of your Premier membership.</span>
                                                <span>*Only available for shipped items.</span>
                                            </div> : 
                                            <div className='d-flex flex-column text-muted'>
                                                <span className='w-90'>Protect against loss, damage, theft & offset emissions for ${this.state.showGDModal ? parseFloat(this.state.seelGDData?.price.toString()).toFixed(2) : <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img>}.</span>
                                                <span>*Only available for shipped items.</span>
                                            </div>    
                                    }          
                                </div>
                            </div>
                            <div class="w-10 d-flex justify-content-end custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="deliveryguarantee" checked={this.state.isdeliveryguarantee} disabled={this.state.ispremierCredit} onChange={this.changeDeliveryGuarantee} />
                                <label class="custom-control-label" for="deliveryguarantee"></label>
                            </div>
                        </div> : '' 
                    }
                </div> : 
                this.state.showSeelLoading || this.state.showGDSeelLoading ? 
                <div className='d-flex flex-column rounded align-items-center text-danger' style={{ padding: "10px 20px 10px 20px", backgroundColor: "#F5F4FF" }}>
                    <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img>
                </div> : ''
            }

            {
                this.state.showSeelErrorMessage || this.state.showGDSeelErrorMessage ? 
                <div className='d-flex flex-column rounded text-center text-danger' style={{ padding: "10px 20px 10px 20px", backgroundColor: "#F5F4FF" }}>
                    {this.state.showSeelErrorMessage ? this.state.showSeelErrorMessage : this.state.showSeelErrorMessage}
                    {this.state.showGDSeelErrorMessage ? this.state.showGDSeelErrorMessage : this.state.showGDSeelErrorMessage}
                </div> : '' 
            }
        </>
    )

    getSeelDetails = (type) => {
        let data = {
            "saleid": this.saleId,
            "itemid": this.itemId,
            "bidprice": type == "buyNow" ? this.state.itemsDetails.buynowprice : this.state.placeBidForm.amount.value, 
            "itemreceiptmethod": type == "buyNow" ? this.state.buynowItemReceiptValue : this.state.itemReceiptValue
        }
        this.setState({
            showSeelLoading: true
        })
        axios.post(getBuyersUrl(seelDetailsData), {data: data}, getBuyerHeaders(true, '', '', "seel")).then(
            response => {
                this.setState({
                    showSeelLoading: false,
                });
                if(response.data.status == "success") {
                    if(typeof response.data?.data == 'object') {
                        if(response.data.data.status == "accepted") {
                            this.setState({
                                seelData: response.data.data,
                                showRAModal: true,
                                isreturnassurance: false
                            })
                        }
                    }
                }
            }
        ).catch((error) => {
            this.setState({
                showSeelLoading: false,
            }, () => {
                if (error.response.data.ctbidserrorcode == "CBRA001") {
                    this.setState({
                        showSeelErrorMessage: "RA insurance not available for this item Please contact CTBIDSHelp for any queries.",
                    })
                }
            });
        })
    }

    getSeelGDDetails = (type) => {
        let data = {
            "saleid": this.saleId,
            "itemid": this.itemId,
            "bidprice": type == "buyNow" ? this.state.itemsDetails.buynowprice : this.state.placeBidForm.amount.value, 
            "itemreceiptmethod": type == "buyNow" ? this.state.buynowItemReceiptValue : this.state.itemReceiptValue
        }
        this.setState({
            showGDSeelLoading: true
        })
        axios.post(getBuyersUrl(seelGDDetailsData), {data: data}, getBuyerHeaders(true, '', '', "seel")).then(
            response => {
                this.setState({
                    showGDSeelLoading: false,
                });
                if(response.data.status == "success") {
                    if(typeof response.data?.data == 'object') {
                        if(response.data.data.status == "accepted") {
                            let remainingCredits = response.data.data.credits.remainingcredits;
                            this.setState({
                                seelGDData: response.data.data,
                                showGDModal: true,
                                isdeliveryguarantee: this.props.user.membershipCompleted && remainingCredits > 0 ? true : false,
                                ispremierCredit: remainingCredits > 0 ? true : false
                            })
                        }
                    }
                }
            }
        ).catch((error) => {
            this.setState({
                showGDSeelLoading: false,
            }, () => {
                if (error.response.data.ctbidserrorcode == "CBRA001") {
                    this.setState({
                        showGDSeelErrorMessage: "RA insurance not available for this item Please contact CTBIDSHelp for any queries.",
                    })
                }
            });
        })
    }

    getPlaceBidSeelData = (type) => {
        if(type == "buynow") {
            this.getSeelDetails("buyNow");
            if(this.state.itemReceiptValue == "shipping" || this.state.buynowItemReceiptValue == "shipping") {
                this.getSeelGDDetails("buyNow");
            }
        } else {
            if(!(parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue))) {
                this.getSeelDetails();
                if(this.state.itemReceiptValue == "shipping" || this.state.buynowItemReceiptValue == "shipping") {
                    this.getSeelGDDetails();
                }
            }
        }
    }

    getIrmDetails = () => {
        axios.get(getBuyersUrl(`${irmDetails}${this.saleId}/${this.itemId}`), getBuyerHeaders()).then(
            response => {
                this.setState({
                    irmSelected: response.data.data,
                    bidderIRMChecked: response.data?.data[0]?.itemreceiptmethod,
                })
            }
        ).catch((error) => {
            console.log(error)
        })
    }

    getEligibleCategoryandLocation = () => {
        let data = { "contentkey": ["rav2", "gdv2"] }
        axios.post(getSellerUrl(eligibleCategoryandLocation), {data: data}).then(
            response => {
                this.setState({
                    raEligibleList: response.data.data.rav2,
                    dgEligibleList: response.data.data.gdv2
                })
            }
        )
    }

    render() {
        return (
            <div className="item-view-main" ref={this.itemViewRef} onScroll={this.handleScroll}>
                <Helmet>
                    <title>{this.itemTitle ? this.itemTitle : this.state.itemsDetails.title}</title>
                    <meta name='description' content={this.state.itemsDetails.category + ' ' + this.state.itemsDetails.tag} />
                    <link rel="canonical" href={`${this.state?.prevPath ? `https://ctbids.com${this.state?.prevPath}` : this.props?.location?.pathname ? `https://ctbids.com${this.props.location.pathname}` : 'https://ctbids.com'}`} />
                </Helmet>
                {
                    this.state.pageLoading && !this.state.noDataFound ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        !this.state.noDataFound ?
                            <div className="items-view">
                                {
                                    this.state.isVisible ?
                                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={() => this.scrollToItemView('Up')}>
                                            <i className="fas fa-arrow-up"></i>
                                        </div> : null
                                }
                                <div className="breadcrumb-section d-lg-flex align-items-center justify-content-between">
                                    <div className="back-and-title d-md-flex align-items-center">
                                        <div className="d-flex align-items-center clickable" onClick={this.back}>
                                            <div className="icon">
                                                <i className="fas fa-angle-left"></i>
                                            </div>
                                            <div className="text" style={{ color: '#A50050'}}>Back</div>
                                        </div>
                                        <div className="border-set"></div>
                                        <div className="title">
                                            <div>
                                                {this.state.itemsDetails.saletitle}
                                            </div>
                                            <div className="description d-flex align-items-end">
                                                <div className="description-text text-muted" dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.provenance) }} ref={this.readMore}></div>
                                                <div className={`read-content clickable ${this.readMoreShowAndHide() ? '' : 'd-none'}`} onClick={this.saleTitleReadMoreHandle}>
                                                    <span className="remove-color">...</span> read {this.state.saleTitleReadMore ? 'less' : 'more'} <i className={`fas ${this.state.saleTitleReadMore ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="more-options d-md-flex align-items-center">
                                        <div className="normal-button clickable" onClick={this.estateSale}>
                                            More Items from this Estate Sale
                                        </div>
                                        {this.state?.itemsDetails?.salestatus !== "Started" && this.state?.itemsDetails?.salecount > 0 && <div className="normal-button clickable" onClick={this.moreSale}>
                                            More Sales from this Location
                                        </div>}
                                        <div className="view-seller clickable" onClick={() => this.scrollToItemView('Down')}>
                                            View seller
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.saleTitleReadMore ?
                                        <div className="sale-title-more d-flex justify-content-center">
                                            <div className="description-text" dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.provenance) }}></div>
                                        </div> : null
                                }
                                <div className="d-flex align-items-center justify-content-center details-section-main">
                                    <div className="large-screen-width">
                                        <div className="d-flex align-items-center previous-next-container">
                                            {this.previousItemId &&
                                                <Button className="normal-button clickable" style={{ backgroundColor: '#A50050', border: '1px solid #A50050' }}
                                                    disabled={this.state.nextButtonClicked || this.state.previousButtonClicked}
                                                    onClick={() => this.onPreviousNextClick(true)}>
                                                    Previous {this.state.previousButtonClicked && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                                                </Button>}
                                                {/* Time taken to load this page { this.state.timeTaken } ms */}
                                            {this.nextItemId &&
                                                <Button className="normal-button clickabl next-item-button" style={{ backgroundColor: '#A50050', border: '1px solid #A50050' }}
                                                    disabled={this.state.nextButtonClicked || this.state.previousButtonClicked}
                                                    onClick={() => this.onPreviousNextClick()}>
                                                    Next {this.state.nextButtonClicked && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                                                </Button>}
                                        </div>
                                        <div className="items-details-section">
                                            <Row className="image-container">
                                                <Col lg={5}>
                                                    <div className="d-flex h-100 w-100">
                                                        <div className="select-image d-flex align-items-center flex-column h-100">
                                                            <div className="scroll-up d-flex align-items-center justify-content-center clickable" onClick={() => this.ScrollHandle('Up')}>
                                                                <i className="fas fa-chevron-up"></i>
                                                            </div>
                                                            <div className="all-images" ref={this.imageScrollRef}>
                                                                {
                                                                    this.state.itemImageList.map((media, index) =>
                                                                        <div key={`image_${index}`} className={`select-container clickable d-flex align-items-center justify-content-center ${this.state.activeImage.id === media.id ? 'selected-media' : ''}`} style={{ backgroundColor: media.type === 'video' ? "#392E2E" : 'transparent' }} onClick={() => { this.setActiveImage(media, index) }}>
                                                                            {
                                                                                media.type === 'image' ?
                                                                                    <div style={{
                                                                                        backgroundImage: `url(${media.thumbnailurl ? media.thumbnailurl : media.url})`,
                                                                                    }} className="select select-image-wrapper" /> :

                                                                                    // this.state.windowWidth < 1040 ?
                                                                                    //     <div style={{ alignContent: 'center', justifyContent: 'center', alignItems: 'center' }} className="less-1040" >
                                                                                    //         <i className="far fa-play-circle fa-3x text-white clickable"></i>
                                                                                    //         {
                                                                                    //             this.sidebarthumb[media.id] ?
                                                                                    //                 <img src={this.sidebarthumb[media.id]} alt="thumbnail-new" className="mw-100"></img>
                                                                                    //                 : null
                                                                                    //         }
                                                                                    //     </div> :
                                                                                        <VideoThumbnail
                                                                                            videoUrl={media.url}
                                                                                            thumbnailHandler={(thumbnail) => this.setState({'videoThumbnails': {...this.state.videoThumbnails, [media.id]: thumbnail}})}
                                                                                            onClick={() => console.log('')}
                                                                                        />
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="scroll-down d-flex align-items-center justify-content-center clickable" onClick={() => this.ScrollHandle('Down')}>
                                                                <i className="fas fa-chevron-down"></i>
                                                            </div>
                                                        </div>
                                                        <div ref={this.imageContainer} className={`display-main h-100 d-flex align-items-center justify-content-center ${this.state.noImage ? 'white-bg' : ''}`}>
                                                            <div className={`display-image d-flex align-items-center justify-content-center ${this.state.noImage ? 'flex-column' : ''}`}>
                                                                {
                                                                    this.state.activeImage.type === "image" ?
                                                                        <div className={`img-magnifier-container ${this.state.noImage ? 'd-flex align-items-center justify-content-center flex-column' : ''}`}>
                                                                            {
                                                                                this.state.noImage ? null :
                                                                                    <div className={`img-magnifier-glass ${this.state.magnifierHide ? 'invisible' : ''}`}
                                                                                        style={{ backgroundImage: `url(${this.state.activeImage.url})` }}
                                                                                        ref={this.magnifier}
                                                                                        onMouseMove={this.moveMagnifier}
                                                                                        onMouseOut={(event) => this.toggleMagnifier(event, true, 'leave')}></div>
                                                                            }
                                                                            <img src={this.state.activeImage.url}
                                                                                alt="item-image"
                                                                                onLoad={this.onImageLoad}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    maxWidth: this.state.imgCropWidth || 0,
                                                                                    maxHeight: this.state.imgCropHeight || 0
                                                                                }}
                                                                                className={`media-image ${this.state.noImage ? 'no-image-css' : ''}`}
                                                                                ref={this.magnifierImage}
                                                                                onMouseMove={this.moveMagnifier}
                                                                                onMouseEnter={(event) => this.toggleMagnifier(event, false, 'enter')} />
                                                                        </div> :
                                                                        // this.state.windowWidth < 1040 ?
                                                                        //     this.state.thumbnailArray.length > 0 ?
                                                                        this.state.activeImage.id in this.state.videoThumbnails ?
                                                                                <div className="position-relative d-flex align-items-center justify-content-center">
                                                                                    <i className="far fa-play-circle fa-3x text-white clickable" style={{ position: 'absolute', zIndex: '1' }}
                                                                                        onClick={this.videoPlayModalToggle}></i>
                                                                                    <img src={this.state.videoThumbnails[this.state.activeImage.id]} alt="thumbnail-new" className="mw-100"></img>
                                                                                </div> : null 
                                                                            // <VideoThumbnail
                                                                            //     videoUrl={this.state.activeImage.url} key={this.state.activeImage.url}
                                                                            //     thumbnailHandler={(thumbnail) => console.log(thumbnail)}
                                                                            //     renderThumbnail={true}
                                                                            //     onClick={() => { this.videoPlayModalToggle() }}
                                                                            // />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.windowWidth > 1040 ?
                                                            <div className="d-flex w-100 enlarge-image">
                                                                <div className="select-image d-flex align-items-center flex-column">
                                                                </div>
                                                                <div className={`align-items-center justify-content-center external-link ${this.state.noImage ? 'd-none' : 'd-flex'}`} onClick={() => this.controlClickEvent()}>
                                                                    Click here to enlarge
                                                                </div>
                                                            </div> : null
                                                    }

                                                </Col>
                                                <Col lg={7}>
                                                    <Row className="detail-section">
                                                        <Col md={7}>
                                                            <div className="left-side">
                                                                <div className="title-and-address">
                                                                    <div className="title">
                                                                        {this.state.itemsDetails.title}
                                                                    </div>
                                                                    <div className="address text-muted">
                                                                        {titleCase(this.state.itemsDetails.city)}, {this.state.itemsDetails.state}, {this.state.itemsDetails.zipcode}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    this.state.itemsDetails.itemtypeid === 2 ?
                                                                        <div className="text-muted detail">
                                                                            <Row>
                                                                                <Col xs={6}>
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <div>Current Bid</div>
                                                                                        <div>:</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xs={6}>
                                                                                    {
                                                                                        this.state.getCurrentBidValueStatus === "SUCCESS" ?
                                                                                            <div className="d-flex align-items-center">
                                                                                                ${parseFloat(this.state.currentBid).toFixed(2)}
                                                                                                {/* <div className="ml-12">(Reverse price met)</div> */}
                                                                                                <span style={{ marginLeft: "4px", fontSize: "14px" }} className={`${this.getReservePriceMet().bgColor}`}>{this.getReservePriceMet().message}</span>
                                                                                            </div> :
                                                                                            (this.state.getCurrentBidValueStatus === "REQUEST" ? <img className="loader-gif" src={loaderIcon} alt="loader"></img>
                                                                                                : `--`)}
                                                                                </Col>
                                                                            </Row>
                                                                        </div> : null
                                                                }
                                                                {
                                                                    !CATERGORY.includes(this.state.itemsDetails.category) ? 
                                                                    !this.state.removeBuyNow && this.state.itemsDetails.itemtypeid !== 3 ?
                                                                        <div className="text-muted detail">
                                                                            <Row>
                                                                                <Col xs={6}>
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <div>Buy Now Price</div>
                                                                                        <div>:</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xs={6}>
                                                                                    <div className="price d-flex align-items-center">
                                                                                        ${this.state.itemsDetails.buynowprice ? parseFloat(this.state.itemsDetails.buynowprice).toFixed(2) : '0.00'}
                                                                                        {
                                                                                            this.state.itemsDetails.salestatus === "Started" &&
                                                                                                this.state.itemsDetails.itemstatus === "Ready" &&
                                                                                                this.state.itemsDetails.buynowprice > 0 &&
                                                                                                !this.state.removeBuyNow &&
                                                                                                this.props.user.profilecompleted !== 0
                                                                                                && this.state.duration?.asMinutes() > 5 ?
                                                                                                <div className={`buy-now clickable ${(this.state.duration && this.state.duration?.asMinutes() < 5) || !this.props.user.active  ? "disabled" : ""}`} onClick={this.buyNow}>Buy Now</div> : null
                                                                                        }

                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </div> : null 
                                                                        : ""
                                                                }

                                                                <div className="text-muted detail">
                                                                    <Row>
                                                                        <Col xs={6}>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <div>Purchase Type</div>
                                                                                <div>:</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={6}>{this.state.itemsDetails.itemtypename}<span style={{ color: "#2499FF", fontSize: "14px" }}>{this.state.itemsDetails.itemtypename === "Auction" && this.state.itemsDetails.reserveprice > 0 ? " With Reserve" : ""}</span></Col>
                                                                    </Row>
                                                                </div>
                                                                {
                                                                    this.state.itemsDetails.itemtypeid === 2 && this.state.itemsDetails.salestatus === "Started" ?
                                                                        <div className="text-muted detail">
                                                                            <Row>
                                                                                <Col xs={6}>
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <div>Bid History</div>
                                                                                        <div>:</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xs={6}>
                                                                                    {
                                                                                        this.state.getCurrentBidValueStatus === "SUCCESS" ? isAuthorized() ?
                                                                                            <div className="external-link" onClick={this.bidHistoryModalToggle}>{this.state.bidHistory.length} Bid History</div>
                                                                                            : <div className="external-link" onClick={this.signIn}>Sign in to view</div> :
                                                                                            (this.state.getCurrentBidValueStatus === "REQUEST" ? <img className="loader-gif" src={loaderIcon} alt="loader"></img>
                                                                                                : `--`)}
                                                                                </Col>
                                                                            </Row>
                                                                        </div> : null
                                                                }
                                                                {
                                                                    this.state.itemsDetails.itemtypeid === 2 && this.state.itemsDetails.salestatus === "Started" && isAuthorized() ?


                                                                        <div className="text-muted detail">
                                                                            <Row>
                                                                                <Col xs={6}>
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <div>Highest Bidder</div>
                                                                                        <div>:</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col style={{wordBreak: 'break-word'}} xs={6}>{this.state.highestBidder}</Col>
                                                                            </Row>
                                                                        </div> : null
                                                                }
                                                                <div className="text-muted detail">
                                                                    <Row>
                                                                        <Col xs={6}>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <div>Category</div>
                                                                                <div>:</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={6}>{this.state.itemsDetails.category ? this.state.itemsDetails.category : '-'}</Col>
                                                                    </Row>
                                                                </div>
                                                                <div className="text-muted detail">
                                                                    <Row>
                                                                        <Col xs={6}>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <div>Item Views</div>
                                                                                <div>:</div>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={6}>{this.state.itemsDetails.itemviewcount}</Col>
                                                                    </Row>
                                                                </div>
                                                                {
                                                                    this.state.itemsDetails.itemtypeid !== 3 ?

                                                                        <div className="text-muted detail">
                                                                            <Row>
                                                                                <Col xs={6}>
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <div>Buyer's Premium</div>
                                                                                        <div>:</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xs={6}>{this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0}%</Col>
                                                                            </Row>
                                                                        </div> : null
                                                                }
                                                                {
                                                                    this.state.itemsDetails.itemstatus !== "Pending" ?
                                                                        <div className="text-muted detail">
                                                                            <Row>
                                                                                <Col xs={6}>
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <div>Item Closes</div>
                                                                                        <div>:</div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col xs={6}>
                                                                                    {
                                                                                        this.betweenCheck() || this.itmeIsClosed() || this.state.itemsDetails.itemstatus !== "Ready" || this.state.checkingTime ?
                                                                                            <div style={{ color: '#9f2241' }}>{this.numberDaysInWord()}</div> :
                                                                                            <>{this.getCloseinDatetime(this.state.itemsDetails.itemclosetime)}</>
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        </div> : null
                                                                }

                                                            </div>
                                                        </Col>
                                                        <Col md={5}>
                                                            <div className="right-side h-100 d-flex flex-column justify-content-between">

                                                                <div className="time-section d-flex flex-column align-items-end">
                                                                    {/* <div className="clickable refresh-time" onClick={this.updateItemDetails}>
                                                                        <i className="fas fa-history"></i> Refresh Time
                                                                    </div> */}
                                                                    <div className={`duration ${this.state.duration_bg_color}`}>
                                                                        {
                                                                            typeof this.state.itemsDetails.itemclosetime === 'string' ? 
                                                                            this.betweenCheck() || this.itmeIsClosed() || this.state.itemsDetails.itemstatus !== "Ready" || this.state.checkingTime ?
                                                                                <div className="closing-now">
                                                                                    {
                                                                                        this.state.connectionError ? isAuthorized() ? "Oops, something went wrong... Try to refresh the page, or log out and log in again." : "Oops, something went wrong... Try to refresh the page." :
                                                                                            this.state.checkingTime ? 'Checking Item Closing Time' :
                                                                                                this.state.itemsDetails.itemstatus !== "Ready" ? this.state.itemsDetails.itemstatus === "Pending" ? "Item not available" : "Item closed" :
                                                                                                    this.itmeIsClosed() ? this.checkItClosedInBE() : "Less than a minute to bid"
                                                                                    }
                                                                                </div> :
                                                                                this.state.duration ?
                                                                                    <div>
                                                                                        <div className="count">
                                                                                            <div className="day">
                                                                                                {/* <div className="word">DAYS</div> */}
                                                                                                <div className="num">
                                                                                                    <span>{minTwoDigits(getDays(this.state.duration?.asDays()))}</span>
                                                                                                    <span className="text">d</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="hr">
                                                                                                {/* <div className="word">HRS</div> */}
                                                                                                <div className="num">
                                                                                                    <span>{minTwoDigits(this.state.duration?.hours())}</span>
                                                                                                    <span className="text">h</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="min">
                                                                                                {/* <div className="word">MIN</div> */}
                                                                                                <div className="num">
                                                                                                    <span>{minTwoDigits(this.state.duration?.minutes())}</span>
                                                                                                    <span className="text">m</span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="sec">
                                                                                                {/* <div className="word">SEC</div> */}
                                                                                                <div className="num">
                                                                                                    <span>{minTwoDigits(this.state.duration?.seconds())}</span>
                                                                                                    <span className="text">s</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="no-of-days text-muted text-end">
                                                                                            {this.numberDaysInWord()}
                                                                                            <div className="d-flex align-items-center justify-content-end">
                                                                                                <OverlayTrigger
                                                                                                    trigger={['hover', 'focus']}
                                                                                                    placement={'bottom-end'}
                                                                                                    overlay={
                                                                                                        <Popover id={`popover-positioned`}>
                                                                                                            <Popover.Content>
                                                                                                                <strong> Auction Time Details </strong>
                                                                                                                - Our countdown clock keeps you aware of how much time you have left to win your desired item. The clock will show you remaining time to bid and then give you a less than a minute remaining alert. Clocks are automatically updated when bidding time extensions are added and an additional check for additional time is also done at item closing. In the event an automatic update was not received by your browser or device, a page refresh will always check and refresh the time. Rest assured that the system runs on one master clock and everyone is on a level playing field of bidding time.
                                                                                                            </Popover.Content>
                                                                                                        </Popover>
                                                                                                    }
                                                                                                >
                                                                                                    <div className="dot"></div>
                                                                                                </OverlayTrigger>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div> : null
                                                                                    : 
                                                                                    <div className='closing-now'> 
                                                                                        {
                                                                                            this.state.checkingTime ? 'Checking Item Closing Time' : "Item not available"
                                                                                        }
                                                                                    </div>
                                                                        }
                                                                    </div>
                                                                    {
                                                                        this.itmeIsClosed() && this.state.itemsDetails.itemstatus !== "Pending" ?
                                                                            <div className="close-date">
                                                                                on {this.formatDate()}
                                                                            </div> : null
                                                                    }
                                                                </div>
                                                                <div className="bid-section mt-2">
                                                                    
                                                                    {
                                                                        this.state.itemsDetails.isshippable === 0 ?
                                                                            <div className="d-flex align-items-center justify-content-end">
                                                                                <div className="pick-up-detail d-flex align-items-center justify-content-end">
                                                                                    <div className="image">
                                                                                        <img src={`${process.env.PUBLIC_URL}/static/images/Common/pickup.svg`} alt="pickup"></img>
                                                                                    </div>
                                                                                    <div className="address-section">
                                                                                        <div className="pick-up-text">This item is pick-up only in</div>
                                                                                        <div className="address">{titleCase(this.state.itemsDetails.city)}, {this.state.itemsDetails.state}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div> :
                                                                            <div className="d-flex align-items-center justify-content-end">
                                                                                <div className="pick-up-detail shippable d-flex align-items-center justify-content-end">
                                                                                    <div className="image">
                                                                                        <img src={shippable} alt="shippable"></img>
                                                                                    </div>
                                                                                    <div className="address-section">
                                                                                        <div className="pick-up-text">This item is shippable</div>
                                                                                        <div className="address">{titleCase(this.state.itemsDetails.city)}, {this.state.itemsDetails.state}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                    }
                                                                    {(this.state.itemIrm.includes("shipping") || this.state.itemIrm.includes("pickup")) && 
                                                                    this.state.raEligibleList.raeligiblelocation && this.state.raEligibleList["raeligiblelocation"].includes(this.state.itemsDetails?.locationid) && 
                                                                    this.state.raEligibleList["raeligiblecategory"][this.state.itemsDetails?.categoryGroup].includes(this.state.itemsDetails.category) && 
                                                                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) >= this.state.raEligibleList["rapricerange"].minamount && 
                                                                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) <= this.state.raEligibleList["rapricerange"].maxamount ?
                                                                     <div className='d-flex align-items-center justify-content-end mb-2 mt-2'>
                                                                        <img src={`${process.env.PUBLIC_URL}/static/images/MakeItReturnable.png`} alt="" style={{ width: '35px' }} /><span style={{  fontWeight: 'bold', color: '#00263E',  marginLeft: '5px' }} > Make It Returnable Eligible
                                                                        </span><OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement={'top'}
                                                                            overlay={
                                                                                <Popover id={`popover-positioned`}>
                                                                                    <Popover.Content>
                                                                                    Bid price between $15 to $1000 is eligible.
                                                                                    </Popover.Content>
                                                                                </Popover>
                                                                            } className="custom-overlay-trigger">
                                                                            <img style={{ width: "20px" , marginLeft: '5px'}} src={`${process.env.PUBLIC_URL}/static/images/berryicon.svg`} alt='info-icon' />
                                                                        </OverlayTrigger>
                                                                    </div> : null}

                                                                    {this.state.itemIrm.includes("shipping") && 
                                                                    this.state.dgEligibleList.gdeligiblelocation && this.state.dgEligibleList["gdeligiblelocation"].includes(this.state.itemsDetails?.locationid) && 
                                                                    this.state.dgEligibleList["gdeligiblecategory"][this.state.itemsDetails?.categoryGroup].includes(this.state.itemsDetails.category) && 
                                                                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) >= this.state.dgEligibleList["gdpricerange"].minamount && 
                                                                    (this.state.itemsDetails.itemtypeid == 1 ? this.state.itemsDetails.buynowprice : this.state.currentBid) <= this.state.dgEligibleList["gdpricerange"].maxamount ?
                                                                     <div className='d-flex align-items-center justify-content-end mb-2 mt-2'>
                                                                        <img src={`${process.env.PUBLIC_URL}/static/images/guarateedDelivery.png`} alt="" style={{ width: '30px' }} /><span style={{  fontWeight: 'bold', color: '#00263E',  marginLeft: '5px' }} > Delivery Guarantee Eligible
                                                                        </span><OverlayTrigger
                                                                            trigger={['hover', 'focus']}
                                                                            placement={'top'}
                                                                            overlay={
                                                                                <Popover id={`popover-positioned`}>
                                                                                    <Popover.Content>
                                                                                    Bid price between $15 to $1000 is eligible.
                                                                                    </Popover.Content>
                                                                                </Popover>
                                                                            } className="custom-overlay-trigger">
                                                                            <img style={{ width: "20px" , marginLeft: '5px'}} src={`${process.env.PUBLIC_URL}/static/images/berryicon.svg`} alt='info-icon' />
                                                                        </OverlayTrigger>
                                                                    </div> : null}
                                                                    {
                                                                        this.state.itemsDetails.itemtypeid === 2 && isAuthorized() && this.state.bidHistoryData?.myproxyprice ?
                                                                            <div className="text-muted detail d-flex align-items-center justify-content-end">
                                                                                <div className="pr-20">My Proxy Bid</div>
                                                                                <div className="amount-width">${parseFloat(this.state.bidHistoryData.myproxyprice).toFixed(2)}</div>
                                                                            </div> : null
                                                                    }
                                                                    {
                                                                        this.state.itemsDetails.itemtypeid === 2 ?
                                                                            <div className="text-muted detail d-flex align-items-center justify-content-end">
                                                                                <div className="bold-text pr-20">Current Bid</div>
                                                                                <div className="amount-width">{
                                                                                    this.state.getCurrentBidValueStatus === "SUCCESS" ?
                                                                                        parseFloat(this.state.currentBid).toFixed(2) :
                                                                                        (this.state.getCurrentBidValueStatus === "REQUEST" ? <img className="loader-gif" src={loaderIcon} alt="loader"></img>
                                                                                            : `--`)}
                                                                                </div>
                                                                            </div> : null
                                                                    }
                                                                    {
                                                                        this.state.itemsDetails.itemtypeid === 2 ?
                                                                            <div className="text-muted detail d-flex align-items-center justify-content-end">
                                                                                <div className="pr-20">Minimum</div>
                                                                                <div className="amount-width">${parseFloat(this.state.currentBid + this.state.incrementvalue).toFixed(2)}</div>
                                                                            </div> : null
                                                                    }
                                                                    {
                                                                        this.state.itemsDetails.itemtypeid === 2 ?
                                                                            <div className="text-muted detail d-flex align-items-center justify-content-end">
                                                                                <div className="pr-20">Increment</div>
                                                                                <div className="amount-width">${parseFloat(this.state.incrementvalue).toFixed(2)}</div>
                                                                            </div> : null
                                                                    }

                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <div className="d-md-flex align-items-center justify-content-between">
                                                        <div className="bottom">
                                                            <Button className={`${this.watching() ? 'btn-secondary' : 'btn-outline-primary watch-button'} d-flex align-items-center justify-content-between`}
                                                                type="button" size="sm" onClick={(event) => { this.watch(event) }} ref={(buttonDOM) => { this[`buttonDOM`] = buttonDOM; }}
                                                                disabled={this.state.itemsDetails.itemstatus !== "Ready"}>Watch<i className="far fa-eye"></i></Button>
                                                        </div>
                                                        <div className="d-lg-flex align-items-start">
                                                            <ToasterMessage className="alert-handle" ref={this.toasterMessage}></ToasterMessage>
                                                            <div className="d-flex flex-column">
                                                                <div className="bid-input-section">
                                                                    {
                                                                        this.state.itemsDetails.itemtypeid === 2 ?

                                                                            <InputGroup className={`${this.props.user?.profilecompleted === 1 ? 'mb-3' : ''}`}>
                                                                                <FormControl
                                                                                    size="lg"
                                                                                    placeholder="Bid Amount"
                                                                                    aria-label="Bid"
                                                                                    className="bid-input"
                                                                                    name="amount"
                                                                                    type="text"
                                                                                    value={this.state.placeBidForm.amount.value}
                                                                                    onChange={(event) => this.onInputValidation(event, 'placeBidForm', 2)}
                                                                                    disabled={this.state.itemsDetails.itemstatus !== "Ready" || this.state.itemsDetails.itemclosetime == null}
                                                                                />
                                                                                <InputGroup.Append>
                                                                                    <Button variant="secondary"
                                                                                        disabled={(!this.state.formValid || this.props.user.profilecompleted === 0 || this.state.itemsDetails.itemstatus !== "Ready" || this.props.user.paymentcompleted === 0) || this.state.placebidLoading || this.state.placeBidForm.amount.value <= 0} onClick={this.placeBidConfirmModal}>
                                                                                        Bid {this.state.placebidLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                                                    </Button>
                                                                                </InputGroup.Append>
                                                                            </InputGroup>
                                                                            : null
                                                                    }
                                                                </div>
                                                                {
                                                                   this.props.user.profilecompleted === 0 && isAuthorized() ?
                                                                        <small className="text-danger text-danger-font">Complete Profile to bid. <span className="external-link" onClick={this.profileComplete}>Click here to update.</span></small> : this.props.user.paymentcompleted === 0 && isAuthorized() ?
                                                                        <small className="text-danger text-danger-font">Complete Payment Method to bid. <span className="external-link" onClick={() => {this.paymentComplete()}}>Click here to update.</span></small> : null
                                                                }
                                                                {/* {
                                                                    this.state.itemsDetails.itemtypeid === 2 ?
                                                                        <div className="d-flex align-items-center justify-content-end">
                                                                            Auction Items Use Proxy Bidding
                                                                            <OverlayTrigger
                                                                                trigger={['hover', 'focus']}
                                                                                placement={'bottom-end'}
                                                                                overlay={
                                                                                    <Popover id={`popover-positioned`}>
                                                                                        <Popover.Content>
                                                                                            <strong> Proxy Bidding </strong>
                                                                                            - An automatic method of bidding that increases your bid to the next lowest price when another user bids on the same item. Your bid is increased by the minimum increment over a competing bidder's bid until your maximum
                                                                                            bid amount is reached or the auction ends unless the item has a reserve and your maximum bid is less than the reserve, your maximum bid amount will be shown.
                                                                                            Extra time will be added when bids are placed near the time that the sale begins to close to allow all bidders the same chance to win the item. The earliest bidder wins when two bidders place the same maximum bid amount.
                                                                                        </Popover.Content>
                                                                                    </Popover>
                                                                                }
                                                                            >
                                                                                <div className="dot"></div>
                                                                            </OverlayTrigger>
                                                                        </div> : null
                                                                } */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="more-details-section">
                                            <div className="items-extra-details">
                                                <div className="top-header">
                                                    Item Details
                                                </div>
                                                <div className="normal-text">
                                                    <div>
                                                        {this.state.itemsDetails.title}
                                                    </div>
                                                    <div className='message-wrap' dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.description) }}></div>
                                                </div>
                                                <div className="items-detail d-flex">
                                                    <div className="dimensions">
                                                        <div className="d-flex items-sku">
                                                            <div className="left-side">
                                                                Item SKU
                                                            </div>
                                                            <div className="right-side" style={{ wordBreak: "break-all" }} >
                                                                {this.state.itemsDetails.SKU}
                                                            </div>
                                                        </div>
                                                        <div className="d-flex items-sku">
                                                            <div className="left-side">
                                                                Dimensions
                                                            </div>
                                                            <div className="right-side">
                                                              Length {this.state.itemsDetails.length ? this.state.itemsDetails.length : 0} /Width {this.state.itemsDetails.width ? this.state.itemsDetails.width : 0} /Height {this.state.itemsDetails.height ? this.state.itemsDetails.height : 0}  (inches)
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.itemsDetails.weight ?
                                                                <div className="d-flex items-sku">
                                                                    <div className="left-side">
                                                                        Weight
                                                                    </div>
                                                                    <div className="right-side">
                                                                        {this.state.itemsDetails.weight} (lbs)
                                                                    </div>
                                                                </div> : null
                                                        }
                                                        {/* {
                                                            this.state.itemsDetails.condition ?
                                                                <div className="d-flex items-sku">
                                                                    <div className="left-side">
                                                                        Condition
                                                                    </div>
                                                                    <div className="right-side">
                                                                        {this.state.itemsDetails.condition}
                                                                        <OverlayTrigger
                                                                            
                                                                            trigger={['hover', 'focus']}
                                                                            placement={'right'}
                                                                            overlay={
                                                                                <Popover id={`popover-positioned`}>
                                                                                    <Popover.Content>
                                                                                    {this.getDescription(this.state.itemsDetails.condition)}
                                                                                    </Popover.Content>
                                                                                </Popover>
                                                                            } className="custom-overlay-trigger">
                                                                            <img style={{ width: "19px" , marginLeft: '5px'}} src={`${process.env.PUBLIC_URL}/static/images/berryicon.svg`} alt='info-icon' />
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </div> : null
                                                        } */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="comments-details">
                                                <div className="top-header d-flex align-items-center">
                                                    Comments
                                                    {
                                                        isAuthorized() && this.state.suspendList.length === 0 ?
                                                            <button className={`ask-a-question-button`}  onClick={this.askAQuestionModal}>Ask Seller a Question</button>
                                                            : null
                                                    }
                                                </div>
                                                {
                                                    this.state.messageList.map((message, index) =>
                                                        <div className="shipping d-flex flex-column" key={`messgae_${index}`}>
                                                            <div className="d-flex">
                                                                <div className="left-side remove-weight message-l pr-2">
                                                                    {message.createdby}
                                                                </div>
                                                                <div className="right-side message-r">
                                                                    {message.message}
                                                                </div>
                                                            </div>
                                                            {
                                                                message.reply.length > 0 ?
                                                                    <div className="d-flex mt2">
                                                                        <div className="left-side remove-weight message-l pr-2">
                                                                            Seller
                                                                        </div>
                                                                        <div className="right-side message-r">
                                                                            {
                                                                                message.reply.map((reply, subIndex) =>
                                                                                    <div className="text-muted" key={subIndex}>{reply.reply}</div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div> : null
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="shipping-details">
                                                <div className="top-header">
                                                    Pickup and Shipping Details
                                                </div>
                                                {
                                                    this.state.itemsDetails.pickupinfo ?
                                                        <div className="pick-up-details d-flex">
                                                            <div className="left-side w-80">
                                                                Pickup
                                                            </div>
                                                            <div className="right-side pick-up-width">
                                                                {this.state.itemsDetails.pickupinfo}
                                                            </div>
                                                        </div> :
                                                        null
                                                }

                                                <div className="notes d-flex">
                                                    <div className="left-side"></div>
                                                    <div className="right-side">
                                                        <div style={{ wordBreak: 'break-word'}} className='message-wrap' dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.shippinginfo) }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="payment-details">
                                                <div className="top-header">
                                                    Payment Details
                                                </div>
                                                <div className="notes d-flex">
                                                    <div className="left-side"></div>
                                                    <div className="right-side">
                                                        <div style={{ wordBreak: 'break-word'}} className='message-wrap' dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.paymentinfo) }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="seller-details">
                                                <div className="top-header">
                                                    Seller Details
                                                </div>
                                                <div className="d-lg-flex align-items-start justify-content-start mt-3">
                                                    <div className="left-side">
                                                        <div className="d-md-flex">
                                                            <div className="image-container d-flex align-items-center justify-content-center">
                                                                {
                                                                    this.state.locationImage.filter(x => x.name === 'profile').map((x, index) =>
                                                                        <img className="seller-image" src={x.url} alt="seller" key={`seller_${index}`}></img>
                                                                    )
                                                                }
                                                                {
                                                                    this.state.locationImage.filter(x => x.name === 'profile').length === 0 ? <img className="seller-image" src={image_thumbnail} alt="seller"></img> : null
                                                                }
                                                            </div>
                                                            <div className="seller-more-detail">
                                                                <div className="name fw-700">{this.state.itemsDetails.locationcontactname}</div>
                                                                <div className="email">
                                                                    <i className="fas fa-envelope"></i>&ensp; {this.state.itemsDetails.email}
                                                                </div>
                                                                <div className="mobile">
                                                                    <i className="fas fa-phone-volume"></i>&ensp;&ensp;{this.state.itemsDetails.phone}
                                                                </div>
                                                                <div className="introduction-link clickable" onClick={this.estateSale}>More items from this Estate Sale</div>
                                                                <div className="introduction-link clickable" onClick={this.moreSale}>More Sales from this Location</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="vertical-line"></div>
                                                    <div className="right-side">
                                                        <div className="fw-700 mb-3">
                                                            {this.state.itemsDetails.locationtitle}
                                                        </div>
                                                        <div className="pra">
                                                            {this.state.itemsDetails.locationdescription}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="my-3">
                                                    {this.state.itemsDetails.about}
                                                </div>
                                            </div>
                                            <div className="terms-and-conditions-details">
                                                <div className="top-header">
                                                    Terms and Conditions
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <div className="mb-3">
                                                        <span className="text">
                                                            Bidding Terms &amp; Conditions
                                                        </span>
                                                        <span className="read-more clickable" onClick={() => this.setState({ expandTerms: !this.state.expandTerms })}>
                                                            Read {this.state.expandTerms ? 'less' : 'more'}
                                                        </span>
                                                    </div>
                                                    {
                                                        this.state.expandTerms ?
                                                            <div className="d-flex">
                                                                <div  className='message-wrap' dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.termsandconditions) }}></div>

                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> : null
                }
                {
                    this.state.noDataFound ? <div className="no-data-found h-100 d-flex flex-column align-items-center justify-content-center">
                        <div className="text-center no-data-search-icon">
                            <i className="fas fa-search fa-3x"></i>
                        </div>
                        <div className="text-center h4 text-bold">
                            No results found
                        </div>
                        <div className="text-center text-muted h5">
                            We couldn't find what you're looking for.
                        </div>
                    </div> : null
                }
                <Modal centered show={this.state.buyNowConfirmModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="bid-confirmation">
                            <div className="header">
                                Confirmation
                            </div>
                            {
                                this.state.buyNowModalHandle.loading ?
                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                        <Spinner as="div" animation="border" size="lg" variant="info" className="mx-2"></Spinner>
                                        <div>Please wait...</div>
                                    </div> :
                                    this.state.buyNowModalHandle.message ? <div className="api-error mt-3">
                                        {this.state.buyNowModalHandle.message}
                                    </div> :
                                        <div className="body-content">
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Buy Now Price</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.buynowprice}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Tax</div>
                                                <div className="price">{this.state.itemsDetails.istaxable ? this.state.itemsDetails.tax : 0}%</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Tax Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.taxValue}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Buyer's Premium</div>
                                                <div className="price">{this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0}%</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Buyer's Premium Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.buyerspremium}</div>
                                            </div>
                                            {
                                                this.state.totalPriceForBuyNow.applytaxonbp === 1 ?
                                                    <div className="d-flex align-items-ccenter justify-content-between">
                                                        <div className="text-muted">Tax On BP Amount</div>
                                                        <div className="price">${this.state.totalPriceForBuyNow.taxonbpamount}</div>
                                                    </div> : null
                                            }
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Shipping Fee Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.shippingfee}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Handling Fee Amount</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.handlingfee}</div>
                                            </div>
                                            <div className="d-flex align-items-ccenter justify-content-between">
                                                <div className="text-muted">Total</div>
                                                <div className="price">${this.state.totalPriceForBuyNow.total}</div>
                                            </div>
                                            {/* {this.state.totalPriceForBuyNow.buynowprice < RETURNASSURANCE_VALUE ? this.returnAssuranceInfoModal("BuyNow") : ''} */}
                                        </div>
                            }
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2 modal-button" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                            <Button variant="secondary" onClick={() => this.confirmPaymentSelection()} disabled={this.state.totalPriceForBuyNow.total < 1 || this.state.buynowLoading}>Confirm {this.state.buynowLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                        </div>
                    </Modal.Body>
                </Modal>
                
               <Modal centered show={this.state.itemReciptModel} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        { this.state.irmOptionData[0] === 'pickup' && this.state.irmOptionData.length === 1 ?
                            <>
                                <div className="bid-confirmation text-center text-secondary font-weight-bold ">
                                    You've Selected Pickup!
                                </div>

                                <div className="bid-confirmation text-center text-bold " style={{ padding: '10px 20px 10px 20px' }}>
                                    This is a pickup only item. By selecting Confirm, you acknowledge
                                    you are responsible for receiving this item.
                                </div>

                            </> :
                            <>

                                <div className="bid-confirmation font-weight-bold text-center text-secondary">
                                    If won, how do you want to obtain your item?
                                </div>
                                {/* <div className='text-center font-weight-bold  mt-3'>This decision will apply to all items won in this sale.</div> */}
                                <Form.Group className="d-flex multiple-checkbox center-align mt-3">
                                    {this.state.irmOptionData.map((value, index) => {
                                        return value && <Form.Check custom type="radio" style={{ marginRight: "10px" }} id={value} name="invoiceItemReceipt" label={this.captializeLetter(value)} value={value ? value : ''} onChange={(event) => this.onChangeOption(event)} />
                                    })}
                                </Form.Group>
                            </>
                        }
                        <div className="d-flex align-items-center justify-content-center mt-3 actions">
                            <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                            <Button variant="secondary mx-2" onClick={() => this.confirmIrmMethod()} disabled={this.state.itemReceiptValue === ""} >
                                Confirm
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>

                 <Modal centered show={this.state.shippingModel} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        
                        {
                            this.state.itemReceiptValue === 'shipping' ?
                                <div className="bid-confirmation text-center text-secondary font-weight-bold ">
                                    You've Selected Shipping!
                                </div> :
                                <div className="bid-confirmation text-center text-secondary font-weight-bold ">
                                   You've Selected Delivery!
                                </div>
                        }
                        <div className="bid-confirmation text-center text-muted mt-3">
                            Your item will { this.state.itemReceiptValue === 'shipping' ? "ship" : "be delivered" } to the address listed:
                        </div>
                        <div className="bid-confirmation text-center mt-3">
                            {Object.keys(this.state?.shippingto).map((key) =>
                                 <p className='font-weight-bold' style={{ wordBreak: 'break-all' }}>{this.state?.shippingto[key]}</p> 
                            )}
                        </div>
                     
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>No, Cancel My Decision</Button>
                            <Button variant="secondary mx-2" onClick={() => this.confirmShippingMethod()} >
                                 Yes, Confirm My Decision
                            </Button>
                        </div>
                        <div className="bid-confirmation text-center mt-3 text-muted "  style={{      padding:"0px 10% 0px 10%"}}>
                           If this is not the address you wish to use, please select cancel and navigate to your 
                           personal account to edit the desired shipping address
                        </div>

                    </Modal.Body>
                </Modal> 

                <Modal centered show={!this.state.itemReciptModel ? this.state.bidConfirmModal : false} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="bid-confirmation">
                            <div className="header">
                                Bid Confirmation
                            </div>
                            <div className="body-content">
                                <div className="d-flex align-items-ccenter justify-content-between">
                                    <div className="text-muted">Your Maximum Bid</div>
                                    <div className="price">${this.state.placeBidValue.currentValue}</div>
                                </div>
                                <div className="d-flex align-items-ccenter justify-content-between">
                                    <div className="text-muted">Buyer's Premium</div>
                                    <div className="price">{this.state.itemsDetails.buyerspremium ? this.state.itemsDetails.buyerspremium : 0}%</div>
                                </div>
                                <div className="d-flex align-items-ccenter justify-content-between">
                                    <div className="text-muted">Buyer's Premium Amount</div>
                                    <div className="price">${this.state.placeBidValue.buyerspremiumValue}</div>
                                </div>
                                {
                                    CATERGORY.includes(this.state.itemsDetails.category) ? 
                                        <div className="placebid-bg">
                                            <p>
                                                By placing a bid on this item, you accept the <span className="term-color clickable" onClick={this.showTermsAndCondition}>Terms and Conditions. </span>
                                                This is a speciality purchase, payment must be handled directly with the seller. Upon win, Seller to reach out to secure payment.
                                            </p>
                                        </div> : 
                                          this.state.placeBidForm.amount.value > BID_AMOUNT ? 
                                        <div className="placebid-bg">
                                            <p>
                                                By placing bid on this item, you accept the <span className="term-color clickable" onClick={this.showTermsAndCondition}>Terms and conditions. </span>
                                                Any invoice greater than $5,000 will have a 10% deposit automatically processed at time of win.
                                                Seller to secure remaining payment.
                                            </p>
                                        </div> : ''
                                }
                            </div>
                        </div>
                        {
                            this.state.bidError ?
                                <div className="api-error">
                                    {this.state.bidError}
                                </div> :
                                null
                        }
                        <div className='pt-3'>
                            {this.returnAssuranceModal("Auction")}
                        </div>
                        {
                            this.props.user.profilecompleted === 1 && parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue) ?
                                <div className="api-error mt-3">Minimum amount ${parseFloat(this.state.currentBid + this.state.incrementvalue).toFixed(2)}</div> : null
                        }
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>No, Cancel My Bid</Button>
                            <Button variant="secondary mx-2" onClick={() => this.confirmPlaceBid()} disabled={this.state.bidLoading || parseFloat(this.state.placeBidForm.amount.value) < parseFloat(this.state.currentBid + this.state.incrementvalue)}>
                                Yes, Confirm My Bid {' '} {this.state.bidLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.askAQuestion} animation={false} size="lg" backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="ask-a-question">
                            <div className="header">
                                Ask Seller a Question
                            </div>
                            <div className="info">
                                This will send an email to the seller and also be posted on the item page for others to view, so please avoid using personal information.
                                You can choose to hide the message from the public by checking the "Hide from public" check-box below.
                            </div>
                            <div className="email-address d-flex align-items-center justify-content-between">
                                <div className="email">To: <span>{this.state.itemsDetails.contactemail}</span> </div>
                                <div className="email">From: <span>{this.props.user.lastName}, {this.props.user.firstName}</span></div>
                            </div>
                            <div className="subject">
                                Subject: Question regarding listing with title {this.state.itemsDetails.title}
                            </div>
                            <div>Message</div>
                            <div className="message-box">
                                <textarea className="form-control" name="message" onChange={event => this.onInputValidation(event, 'messageForm', null, 'messageFormValid')}></textarea>
                                {
                                    this.state.messageForm.message.error ? <small className="text-danger mt-10">{this.state.messageForm.message.error}</small> : null
                                }
                            </div>
                            <div className="public">
                                <Form.Check
                                    custom
                                    type="checkbox"
                                    id={`hide`}
                                    label="Hide from public"
                                    name="isPublic"
                                    onChange={event => this.onInputValidation(event, 'messageForm', null, 'messageFormValid', true)}
                                />
                            </div>
                        </div>
                        <div className='d-flex justify-content-center text-center text-danger'>{this.state.suspendedErrorMessage ? this.state.suspendedErrorMessage : ''}</div>
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2 modal-button" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                            {
                                this.state.messageLoading ?
                                    <Button variant="secondary mx-2 modal-button" disabled>
                                        Send {' '} <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
                                    </Button> :
                                    <Button variant="secondary mx-2 modal-button" disabled={!this.state.messageFormValid} onClick={() => this.sendMessage()}>Send</Button>
                            }
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.videoPlayerModal} animation={false} size="lg" onHide={this.videoPlayModalToggle}>
                    <Modal.Header>
                        <div type="button" onClick={() => this.videoPlayModalToggle()} className="close" data-dismiss="modal" variant="outline-primary" aria-label="Close"><span aria-hidden="true">&times;</span></div>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        {
                            this.state.videoPlayerModal ?
                                this.state.windowWidth < 768 ?
                                    // <div id="videoContainer" style={{ position: 'absolute', backgroundColor: 'black' }}>
                                    <video style={{ maxWidth: '100%' }} controls disablePictureInPicture controlsList="nodownload" webkit-playsinline playsinline
                                        poster={this.state.thumbnailArray[0]}>
                                        <source src={this.state.activeImage.url}></source>
                                        Your browser does not support HTML video.
                                    </video>
                                    // </div> :
                                    :
                                    <div>
                                        <video disablePictureInPicture src={this.state.activeImage.url} controls controlsList="nodownload"
                                            autoPlay="autoplay" style={{ maxWidth: '100%', maxHeight: '550px' }} webkit-playsinline playsinline></video>
                                    </div>
                                : null
                        }

                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.bidHistoryModal} animation={false} size="lg" onHide={this.bidHistoryModalToggle}>
                    <Modal.Header>
                        <div type="button" onClick={() => this.bidHistoryModalToggle()} className="close" data-dismiss="modal" variant="outline-primary" aria-label="Close"><span aria-hidden="true">&times;</span></div>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        <div className="w-100 modal-table">
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Bidders</th>
                                        <th>Bid Date</th>
                                        <th>Bid Time</th>
                                        <th>Bid Amount</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.bidHistory.length === 0 ?
                                            <tr>
                                                <td colSpan="5" className="text-center">No Data Found</td>
                                            </tr> :
                                            this.state.bidHistory.map((bidding, index) =>
                                                <tr key={`bid_history_${index}`}>
                                                    <td>{bidding.nickname}</td>
                                                    <td>{dateTimeFormat(bidding.createddate)}</td>
                                                    <td>{dateTimeFormat(bidding.createddate, true)}</td>
                                                    <td>${bidding.bidprice}</td>
                                                    <td>{index === 0 ? 'Current Bid' : 'Out Bid'}</td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={this.state.galleryModal}
                    onHide={() => this.setGalleryModalToggle(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="gallery-modal"
                >
                    <Modal.Body>
                        {
                            this.state.galleryModal ?
                                <div className=".d-none .d-lg-block .d-xl-none gallery-view">
                                    <div className="close-button" onClick={() => this.setGalleryModalToggle(false)}>
                                        <i className="fas fa-times"></i>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="left-side">
                                            <div className="d-flex flex-wrap justify-content-between">
                                                {
                                                    this.state.itemImageList.map((media, index) =>
                                                        <div key={`image_${index}`} className={`select-container clickable d-flex align-items-center justify-content-center ${this.state.galleryMedia.activeImage.id === media.id ? 'selected-media' : ''}`} onClick={() => { this.setActiveImageForGalleryView(media, index) }}>
                                                            {
                                                                media.type === 'image' ?
                                                                    <div style={{
                                                                        backgroundImage: `url(${ media.thumbnailurl ? media.thumbnailurl : media.url})`,
                                                                    }} className="select select-image-wrapper" />
                                                                    :
                                                                    <VideoThumbnail
                                                                        videoUrl={media.url}
                                                                        thumbnailHandler={(thumbnail) => console.log(thumbnail)}
                                                                        onClick={() => console.log('')}
                                                                    />
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div className="right-side">

                                            <div className={`left-button ${this.getButtonDisable('previous') ? 'disable-nav' : ''}`} onClick={this.previousImage}>
                                                <i className="fas fa-chevron-left"></i>
                                            </div>
                                            <div className={`right-button ${this.getButtonDisable('next') ? 'disable-nav' : ''}`} onClick={this.nextImage}>
                                                <i className="fas fa-chevron-right"></i>
                                            </div>
                                            <div className={`select-container d-flex align-items-center justify-content-center`}>
                                                {
                                                    this.state.galleryMedia.activeImage.type === "image" ?
                                                        <div className={`d-flex align-items-center justify-content-center gallery-media-show`} ref={el => this['galleryMedia'] = el}>
                                                            {
                                                                this.state.galleryMedia.isZoomed ?
                                                                    <GalleryImage imageUrl={this.state.galleryMedia.activeImage.url} adjustHeight={this.state.galleryMedia.adjustHeight}
                                                                        adjustWidth={this.state.galleryMedia.adjustWidth} whenClick={this.closeZoom} setHeight={this.state.galleryMedia.styles.height}></GalleryImage>
                                                                    :
                                                                    <img src={this.state.galleryMedia.activeImage.url} alt="active-media" className={`media-image`} ref={el => this['galleryImage'] = el} onClick={this.toggleZoom}
                                                                        style={this.state.galleryMedia.styles} onMouseMove={this.handleGalleryImageMove}
                                                                    ></img>
                                                            }
                                                        </div> :
                                                        this.state.windowWidth < 768 ?
                                                            <div id="videoContainer" style={{ position: 'absolute', backgroundColor: 'black' }}>
                                                                <video style={{ width: '320', height: '240' }} controls disablePictureInPicture controlsList="nodownload" webkit-playsinline playsinline>
                                                                    <source src={this.state.activeImage.url}></source>
                                                                    Your browser does not support HTML video.
                                                                </video>
                                                            </div> :
                                                            <div>
                                                                <video disablePictureInPicture src={this.state.galleryMedia.activeImage.url} controls controlsList="nodownload"
                                                                    autoPlay="autoplay" style={{ maxWidth: '100%', maxHeight: '550px' }} webkit-playsinline playsinline></video>
                                                            </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null
                        }
                    </Modal.Body>
                </Modal>
                <Modal centered
                    animation={false}
                    backdrop="static"
                    enforceFocus={false}
                    show={!this.props.sessionModal && this.state.refreshData?.showModal}
                >
                    <Modal.Body >
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Oops, something went wrong... {isAuthorized() ? <p>Try to refresh the page, or log out and log in again.</p> : <p>Try to refresh the page.</p>}
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" onClick={this.onCloseSomethingWentWrongModal}>Cancel</Button>
                                <Button variant="secondary mx-2" onClick={this.onRefreshSomethingWentWrongModal}>Refresh</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered className="terms-dialog" id="terms-and-condition" show={this.state.estateTermsConditions} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Header centered>
                        <div className="header">Terms &amp; Conditions</div>
                        <div className="terms-close-icon close-icon-1 clickable" onClick={this.handleCloseTerms}>&times;</div>
                    </Modal.Header>
                    <Modal.Body>
                        <div  className='message-wrap' dangerouslySetInnerHTML={{ '__html': stringToHTMLConvert(this.state.itemsDetails.termsandconditions)}}></div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.paymentSelectionModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="payment-close-icon">
                            <div className="close-icon-1 clickable" onClick={this.handleClose}></div>
                        </div>
                        <div className="bid-confirmation">
                            <div className="header" style={{ textAlign: 'center' }}>
                                You have selected a Buy Now or Direct Buy item
                            </div>
                            <div className="body-content justify-content-center">
                            { this.state.closeBuyNowIrmButton ? <>
                                <p className='text-center'> Please select your Item Receipt Method</p>
                               
                                {
                                    
                                    this.state.itemIrm[0] === "pickup" && this.state.itemIrm.length === 1 ?
                                        <Form.Group controlId="pickupOnly" className='body-content'>
                                            <Form.Check custom type="checkbox" className="normal" id="pickupOnly" name="pickupOnly" label="An item you won was designated as Pick Up Only. Please confirm you will pick up the items by clicking the box."
                                                onChange={(event) => this.onChangeBuynowIrm(event)} />
                                        </Form.Group>
                                        :
                                        <div>
                                            <Form.Group className="d-flex multiple-checkbox center-align mt-3">
                                                {this.state.itemIrm.map((value, index) => {
                                                    return value && <Form.Check custom type="radio" style={{ marginRight: "10px" }} id={value} name="invoiceItemReceipt" label={this.captializeLetter(value)} value={value ? value : ''} onChange={(event) => this.onChangeBuynowIrm(event)} />
                                                })}
                                            </Form.Group>
                                        </div>
                                }
                                </> : null}


                            </div>
                            {
                                this.state.buynowItemReceiptValue !== "" ?
                                    <div className="body-content justify-content-center">
                                        {
                                            this.state.confirmBuyNowIrm && this.state.buynowItemReceiptValue !== 'pickup' ? <>
                                                {
                                                    this.state.buynowItemReceiptValue === 'shipping' ?
                                                        <div className="bid-confirmation text-center text-secondary font-weight-bold ">
                                                            You've Selected Shipping!
                                                        </div> :
                                                        this.state.buynowItemReceiptValue === 'delivery' ?
                                                            <div className="bid-confirmation text-center text-secondary font-weight-bold ">
                                                                You've Selected Delivery!
                                                            </div> : null

                                                }

                                                <div className="bid-confirmation text-center text-muted mt-3">Your item will {this.state.buynowItemReceiptValue === 'shipping' ? "ship" : "be delivered"} to the address listed:</div>

                                                <div className="bid-confirmation text-center mt-3">
                                                    {Object.keys(this.state?.shippingto).map((key) =>
                                                        <p className='font-weight-bold' style={{ wordBreak: 'break-all' }}>{this.state?.shippingto[key]}</p>
                                                    )}
                                                </div>
                                            </> : ''}


                                        {
                                            this.state.confirmBuyNowIrm ? <div className="d-flex align-items-center justify-content-center mt-3 actions">
                                                <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeBuyNowConfirm()}>No, Cancel My Decision</Button>
                                                <Button variant="secondary mx-2" onClick={() => this.confirmBuyNowIrm()}  >
                                                    Yes, Confirm My Decision
                                                </Button>

                                            </div> :
                                            <><div className="d-flex align-items-center justify-content-center">
                                                Please select your Payment Method
                                            </div>
                                            <div className="d-flex align-items-center justify-content-center mt-4 actions">
                                                {!this.state.isreturnassurance && !this.state.isdeliveryguarantee ?
                                                    <PayPalScriptProvider options={this.state.payPalConfig.script}>
                                                        <PayPalButtons style={this.state.payPalConfig.buttonStyle} disabled={this.state.paypalbtnDisabled} createOrder={(data, actions) => this.createOrder(data, actions)}
                                                            onApprove={(data, actions) => this.onApprove(data, actions)} fundingSource={FUNDING.PAYPAL} onCancel={this.onCancel} />
                                                    </PayPalScriptProvider> : ''}
                                                {!this.state.disablePaymentMethod ? <Button variant="outline-dark btn-white mx-2 modal-button" style={{ width: '270px', borderRadius: '15px', marginBottom: '7px' }} onClick={() => { this.confirmBuyNow("autodebit"); } } disabled={this.state.paymentConfirmBtn}>
                                                    Payment Method on File {' '} {this.state.paymentConfirmLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                                </Button> : ''}
                                            </div></> 
                                                
                                        }
                                        {this.state.confirmBuyNowIrm && this.state.buynowItemReceiptValue !== 'pickup' ?
                                            <div className="bid-confirmation text-center mt-3 text-muted " style={{ padding: "0px 10% 0px 10%" }}>
                                                If this is not the address you wish to use, please select cancel and navigate to your
                                                personal account to edit the desired shipping address
                                            </div> : ''
                                        }
                                    </div> : ''}
                        </div>
                        {this.state.buynowItemReceiptValue !== "" && this.state.pickupCheckBox && this.state.payPalMessage && !this.state.isreturnassurance && this.state.showBidPlaceBtn && !this.state.isdeliveryguarantee ?
                            <div style={{ fontSize: '12px' }}>
                                A PayPal account is not required, you will have the option to checkout as a guest.
                            </div> : ''}
                            <div className='pt-3'>
                                {this.returnAssuranceModal("BuyNow")}
                            </div>
                        {
                            this.state.paymentError ?
                                <div className="api-error" style={{marginTop: "10px"}}>
                                    {this.state.paymentError}
                                </div> :
                                null
                        }                    
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.deliveryInfoModal} size="lg" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body className='pd-5 modal-resp'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <span className='text-bold'>PROVIDED BY <img class="seel-img-resp" src={`${process.env.PUBLIC_URL}/static/images/seelMain.svg`} alt='seel-icon' /></span>
                            <div className="close-icon" onClick={() => {this.closeSeelInfoModal("deliveryInfoModal")}}>×</div>
                        </div>
                        <div className="body-content d-flex align-items-center justify-content-between flex-row text-center text-muted mt-4 w-100">
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-8'>1 - Click Protect Against</span>
                                <div className='d-flex flex-column text-left'>
                                    <div className="d-flex justify-content-center text-center p-8">
                                        <img src={`${process.env.PUBLIC_URL}/static/images/guarateedDelivery.png`} style={{ width: "30%", margin: "5px  0px 10px 0px" }} alt='guaranteed-delivery-icon' />
                                    </div>
                                    <div>
                                        <img className="w-9 mr-2 ml-70" src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                        <span>Loss</span>
                                    </div>
                                    <div>
                                        <img className="w-9 mr-2 ml-70" src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                        <span>Damage</span>
                                    </div>
                                    <div>
                                        <img className="w-9 mr-2 ml-70" src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                        <span>Theft</span>
                                    </div>
                                </div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-8'>Instant Resolution</span>
                                <div className="d-flex justify-content-center text-center p-8"><img src={`${process.env.PUBLIC_URL}/static/images/thunder.svg`} style={{ width: "25%" }} alt='thunder-icon' /></div>
                                <div className='p-8'>Instantly resolve your shipment issues and get a refund or replacement with a few clicks.</div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-8'>Protect Our Planet</span>
                                <div className="d-flex justify-content-center text-center p-8"><img src={`${process.env.PUBLIC_URL}/static/images/seel.svg`} style={{ width: "30%", padding: "15px 0px 15px 0px" }} alt='seel-icon' /></div>
                                <div className='p-8'>Part of your Delivery Guarantee fee will fund green project to offset emissions from shipping.</div>
                            </div>
                        </div>
                        <div className='mt-4 d-flex align-items-center text-center flex-column'>
                            <p>Delivery Guarantee offers peace of mind against package loss, damage, and theft, while offsetting carbon emissions from shipping for a greener planet. Should any covered incidents occur, 
                                use the <a className='cursor' href='https://resolve.seel.com/' target='_blank'><u>Seel Resolution Center</u></a> to resolve your package issue and get compensation up to the full value of your order!</p>
                            <p>*Delivery Guarantee is not available for pickup and delivery item(s).</p>
                        </div>
                        {/* <div className='d-flex mt-4' style={{ justifyContent: "space-evenly" }}>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/terms/delivery-guarantee") }}><u>Terms Apply</u></span>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/privacy") }}><u>Privacy Policy</u></span>
                        </div> */}
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.returnAssuranceInfoModal} size="lg" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body className='pd-5 modal-resp'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <span className='text-bold'>PROVIDED BY <img class="seel-img-resp" src={`${process.env.PUBLIC_URL}/static/images/seelMain.svg`} alt='seel-icon' /></span>
                            <div className="close-icon" onClick={() => {this.closeSeelInfoModal("returnAssuranceInfoModal")}}>×</div>
                        </div>
                        <div className="body-content d-flex align-items-center justify-content-between flex-row text-center text-muted mt-4 w-100">
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-2 seel-resp'>Return For Any Reason</span>
                                <div className='d-flex flex-column text-left'>
                                    <div className="d-flex justify-content-center text-center p-2">
                                        <img src={`${process.env.PUBLIC_URL}/static/images/MakeItReturnable.png`} style={{ width: "40%" }} alt='make-it-returnable-icon' />
                                    </div>
                                    <div style={{ padding: "5px 0px 0px 10px" }}>
                                        <img className="w-9 mr-2" src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                        <span>No longer needed</span>
                                    </div>
                                    <div style={{ padding: "0px 0px 0px 10px" }}>
                                        <img className="w-9 mr-2" src={`${process.env.PUBLIC_URL}/static/images/check-mark.svg`} alt='check-mark' />
                                        <span>Dissatisfied with items</span>
                                    </div>
                                </div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-2 seel-resp'>Instant Resolution</span>
                                <div className="d-flex justify-content-center text-center p-2"><img src={`${process.env.PUBLIC_URL}/static/images/shield.svg`} style={{ width: "30%" }} alt='shield-icon' /></div>
                                <div style={{ paddingTop: "19px" }}>Bid with confidence.</div>
                                <div>Make a return within 7 days of Pickup or Shipping.</div>
                            </div>
                            <div className='border rounded w-30 h-225'>
                                <span className='d-flex flex-column border-bottom text-secondary text-bold f-16 p-2 seel-resp'>Easy Resolution</span>
                                <div className="d-flex justify-content-center text-center p-2"><img src={`${process.env.PUBLIC_URL}/static/images/thunder.svg`} style={{ width: "25%" }} alt='thunder-icon' /></div>
                                <div className='text-align-center p-2'>Resolve your return request and get refunded with a few clicks.</div>
                            </div>
                        </div>
                        <div className='mt-4 d-flex align-items-center text-center flex-column'>
                            Seel’s Make It Returnable (Return Assurance) are for eligible items from $15 to $1,000. Fees vary. When applicable, sales tax will be included in the price of Make it Returnable. Fees vary.
                        </div>
                        <div className='d-flex mt-4' style={{ justifyContent: "space-evenly" }}>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/privacy") }}><u>Privacy Policy</u></span>
                            <span className='clickable' onClick={() => { this.navigateToUrl("https://www.seel.com/terms/delivery-guarantee") }}><u>Terms of Service</u></span>
                        </div>
                    </Modal.Body>
                </Modal>
            </div >
        );
    }
}

export default connect(state => state)(ItemView);